// material
import { Container, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import SurahSearch from '../sections/@dashboard/blog/SurahSearch';
// components
import Page from '../components/Page';
import { BlogPostCard } from '../sections/@dashboard/blog';
// mock

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'None', label: 'None' },
  { value: 'Makkiyyah', label: 'Makkiyyah' },
  { value: 'Madaniyyah', label: 'Madaniyyah' },
];

// ----------------------------------------------------------------------

export default function Blog() {
  const [alquranReady , setAlquranReady] = React.useState(alquran);

  
  // React.useEffect(()=>{
  //   axios(`https://quran-endpoint.vercel.app/quran`)
  //   .then((response)=> {
  //     setAlquran(response.data.data)
  //     setAlquranReady(response.data.data)
  //   });
  // },[]);

  const setSearchFunc =(v)=> {
    if(v !== null){
      setAlquranReady(alquran.filter((data , index)=> data.number === v.number));
    }else{
      setAlquranReady(alquran);
    }
  }

  return (
    <Page title="Al - Qur'an">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Al Qur'an
          </Typography>
          {/* <Button variant="contained" component={RouterLink} to="#" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Post
          </Button> */}
        </Stack>

        <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between" gap={1}>
          <SurahSearch posts={alquran} setSearch={setSearchFunc}  />
          {/* <BlogPostsSort options={SORT_OPTIONS} setSort={setSortFunc}  /> */}
        </Stack>

        <Grid container spacing={3}>
          {alquranReady.map((post, index) => (
            <BlogPostCard key={post.id} post={post} index={index} />
          ))}
        </Grid>
      </Container>
    </Page>
  );
}

const alquran = [
  {
  "number": 1,
  "ayahCount": 7,
  "sequence": 5,
  "asma": {
  "ar": {
  "short": "الفاتحة",
  "long": "سُورَةُ ٱلْفَاتِحَةِ"
  },
  "en": {
  "short": "Al-Faatiha",
  "long": "Sura Al-Faatiha"
  },
  "id": {
  "short": "Al-Fatihah",
  "long": "Surah Al-Fatihah"
  },
  "translation": {
  "en": "The Opening",
  "id": "Pembukaan"
  }
  },
  "preBismillah": null,
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Faatihah (Pembukaan) yang diturunkan di Mekah dan terdiri dari 7 ayat adalah surat yang pertama-tama diturunkan dengan lengkap  diantara surat-surat yang ada dalam Al Quran dan termasuk golongan surat Makkiyyah. Surat ini disebut Al Faatihah (Pembukaan), karena dengan surat inilah dibuka dan dimulainya Al Quran. Dinamakan Ummul Quran (induk Al Quran) atau Ummul Kitaab (induk Al Kitaab) karena dia merupakan induk dari semua isi Al Quran, dan karena itu diwajibkan membacanya pada tiap-tiap sembahyang. Dinamakan pula As Sab'ul matsaany (tujuh yang berulang-ulang) karena ayatnya tujuh dan dibaca berulang-ulang dalam sholat.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/001.mp3"
  }
  },
  {
  "number": 2,
  "ayahCount": 286,
  "sequence": 87,
  "asma": {
  "ar": {
  "short": "البقرة",
  "long": "سورة البقرة"
  },
  "en": {
  "short": "Al-Baqara",
  "long": "Sura Al-Baqara"
  },
  "id": {
  "short": "Al-Baqarah",
  "long": "Surah Al-Baqarah"
  },
  "translation": {
  "en": "The Cow",
  "id": "Sapi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Baqarah yang 286 ayat itu turun di Madinah yang sebahagian besar diturunkan pada permulaan tahun Hijrah, kecuali ayat 281 diturunkan di Mina pada Hajji wadaa' (hajji Nabi Muhammad s.a.w. yang terakhir). Seluruh ayat dari surat Al Baqarah termasuk golongan Madaniyyah, merupakan surat yang terpanjang di antara surat-surat Al Quran yang di dalamnya terdapat pula ayat yang terpancang (ayat 282). Surat ini dinamai Al Baqarah karena di dalamnya disebutkan kisah penyembelihan sapi betina yang diperintahkan Allah kepada Bani Israil (ayat 67 sampai dengan 74), dimana dijelaskan watak orang Yahudi pada umumnya. Dinamai Fusthaatul-Quran (puncak Al Quran) karena memuat beberapa hukum yang tidak disebutkan dalam surat yang lain. Dinamai juga surat  alif-laam-miim karena surat ini dimulai dengan Alif-laam-miim.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/002.mp3"
  }
  },
  {
  "number": 3,
  "ayahCount": 200,
  "sequence": 89,
  "asma": {
  "ar": {
  "short": "آل عمران",
  "long": "سورة آل عمران"
  },
  "en": {
  "short": "Aal-i-Imraan",
  "long": "Sura Aal-i-Imraan"
  },
  "id": {
  "short": "Ali 'Imran",
  "long": "Surah Ali 'Imran"
  },
  "translation": {
  "en": "The Family of Imraan",
  "id": "Keluarga Imran"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Ali 'Imran yang terdiri dari 200 ayat ini adalah surat Madaniyyah.  Dinamakan Ali 'Imran karena memuat kisah keluarga 'Imran yang di dalam kisah itu disebutkan kelahiran Nabi Isa a.s., persamaan kejadiannya dengan Nabi Adam a. s., kenabian dan beberapa mukjizatnya, serta disebut pula kelahiran Maryam puteri 'Imran, ibu dari Nabi Isa a.s. Surat Al Baqarah dan Ali 'Imran ini dinamakan Az Zahrawaani (dua yang cemerlang), karena kedua surat ini menyingkapkan hal-hal yang disembunyikan oleh para Ahli Kitab, seperti kejadian dan kelahiran Nabi Isa a.s., kedatangan Nabi Muhammad s.a.w. dan sebagainya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/003.mp3"
  }
  },
  {
  "number": 4,
  "ayahCount": 176,
  "sequence": 92,
  "asma": {
  "ar": {
  "short": "النساء",
  "long": "سورة النساء"
  },
  "en": {
  "short": "An-Nisaa",
  "long": "Sura An-Nisaa"
  },
  "id": {
  "short": "An-Nisa'",
  "long": "Surah An-Nisa'"
  },
  "translation": {
  "en": "The Women",
  "id": "Wanita"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat An Nisaa' yang terdiri dari 176 ayat itu, adalah surat Madaniyyah yang terpanjang sesudah surat Al Baqarah. Dinamakan An Nisaa' karena dalam surat ini banyak dibicarakan hal-hal yang berhubungan dengan wanita serta merupakan surat yang paling membicarakan hal itu dibanding dengan surat-surat yang lain. Surat yang lain banyak juga yang membicarakan tentang hal wanita ialah surat Ath Thalaq. Dalam hubungan ini biasa disebut surat An Nisaa' dengan sebutan: Surat An Nisaa' Al Kubraa (surat An Nisaa' yang besar), sedang  surat Ath Thalaq disebut dengan sebutan: Surat An Nisaa' Ash Shughraa (surat An Nisaa' yang kecil).",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/004.mp3"
  }
  },
  {
  "number": 5,
  "ayahCount": 120,
  "sequence": 112,
  "asma": {
  "ar": {
  "short": "المائدة",
  "long": "سورة المائدة"
  },
  "en": {
  "short": "Al-Maaida",
  "long": "Sura Al-Maaida"
  },
  "id": {
  "short": "Al-Ma'idah",
  "long": "Surah Al-Ma'idah"
  },
  "translation": {
  "en": "The Table",
  "id": "Hidangan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Maa'idah terdiri dari 120 ayat; termasuk golongan surat Madaniyyah. Sekalipun ada ayatnya yang turun di Mekah, namun ayat ini diturunkan sesudah Nabi Muhammad s.a.w. hijrah ke Medinah, yaitu di waktu haji wadaa'. Surat ini dinamakan Al Maa'idah (hidangan) karena memuat kisah pengikut-pengikut setia Nabi Isa a.s. meminta kepada Nabi Isa a.s. agar Allah menurunkan untuk mereka Al Maa'idah (hidangan makanan) dari langit (ayat 112). Dan dinamakan Al Uqud (perjanjian), karena kata itu terdapat pada ayat pertama surat ini, dimana Allah menyuruh agar hamba-hamba-Nya memenuhi janji prasetia terhadap Allah dan perjanjian-perjanjian yang mereka buat sesamanya. Dinamakan juga Al Munqidz (yang menyelamatkan), karena akhir surat ini mengandung kisah tentang Nabi Isa a.s. penyelamat pengikut-pengikut setianya dari azab Allah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/005.mp3"
  }
  },
  {
  "number": 6,
  "ayahCount": 165,
  "sequence": 55,
  "asma": {
  "ar": {
  "short": "الأنعام",
  "long": "سورة الأنعام"
  },
  "en": {
  "short": "Al-An'aam",
  "long": "Sura Al-An'aam"
  },
  "id": {
  "short": "Al-An'am",
  "long": "Surah Al-An'am"
  },
  "translation": {
  "en": "The Cattle",
  "id": "Binatang Ternak"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al An'aam (binatang ternak: unta, sapi, biri-biri dan kambing) yang terdiri atas 165 ayat, termasuk golongan surat Makkiyah, karena hampur seluruh ayat-ayat-Nya diturunkan di Mekah dekat sebelum hijrah. Dinamakan Al An'aam karena di dalamnya disebut kata An'aam dalam hubungan dengan adat-istiadat kaum musyrikin, yang menurut mereka binatang-binatang ternak itu dapat dipergunakan untuk mendekatkan diri kepada tuhan mereka. Juga dalam surat ini disebutkan hukum-hukum yang berkenaan dengan binatang ternak itu.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/006.mp3"
  }
  },
  {
  "number": 7,
  "ayahCount": 206,
  "sequence": 39,
  "asma": {
  "ar": {
  "short": "الأعراف",
  "long": "سورة الأعراف"
  },
  "en": {
  "short": "Al-A'raaf",
  "long": "Sura Al-A'raaf"
  },
  "id": {
  "short": "Al-A'raf",
  "long": "Surah Al-A'raf"
  },
  "translation": {
  "en": "The Heights",
  "id": "Tempat Tertinggi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al A'raaf yang berjumlah 206 ayat termasuk golongan surat Makkiyah, diturunkan sebelum turunnya surat Al An'aam dan termasuk golongan surat Assab 'uththiwaal (tujuh surat yang panjang). Dinamakan Al A'raaf karena perkataan Al A'raaf terdapat dalam ayat 46 yang mengemukakan tentang keadaan orang-orang yang berada di atas Al A'raaf yaitu: tempat yang tertinggi di batas surga dan neraka.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/007.mp3"
  }
  },
  {
  "number": 8,
  "ayahCount": 75,
  "sequence": 88,
  "asma": {
  "ar": {
  "short": "الأنفال",
  "long": "سورة الأنفال"
  },
  "en": {
  "short": "Al-Anfaal",
  "long": "Sura Al-Anfaal"
  },
  "id": {
  "short": "Al-Anfal",
  "long": "Surah Al-Anfal"
  },
  "translation": {
  "en": "The Spoils of War",
  "id": "Rampasan Perang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Anfaal terdiri atas 75 ayat dan termasuk golongan surat-surat Madaniyyah, karena seluruh ayat-ayatnya diturunkan di Madinah. Surat ini dinamakan Al Anfaal yang berarti harta rampasan perang berhubung kata Al Anfaal terdapat pada permulaan surat ini dan juga persoalan yang menonjol dalam surat ini ialah tentang harta rampasan perang, hukum perang dan hal-hal yang berhubungan dengan peperangan pada umumnya. Menurut riwayat Ibnu Abbas r.a. surat ini diturunkan berkenaan dengan perang Badar Kubra yang terjadi pada tahun kedua hijrah. Peperangan ini sangat penting artinya, karena dialah yang menentukan jalan sejarah Perkembangan Islam. Pada waktu itu umat Islam dengan berkekuatan kecil untuk pertama kali dapat mengalahkan kaum musyrikin yang berjumlah besar, dan berperlengkapan yang cukup, dan mereka dalam peperangan ini memperoleh harta rampasan perang yang tidak sedikit. Oleh sebab itu timbullah masalah bagaimana membagi harta-harta rampasan perang itu, maka kemudian Allah menurunkan ayat pertama dari surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/008.mp3"
  }
  },
  {
  "number": 9,
  "ayahCount": 129,
  "sequence": 113,
  "asma": {
  "ar": {
  "short": "التوبة",
  "long": "سورة التوبة"
  },
  "en": {
  "short": "At-Tawba",
  "long": "Sura At-Tawba"
  },
  "id": {
  "short": "At-Taubah",
  "long": "Surah At-Taubah"
  },
  "translation": {
  "en": "The Repentance",
  "id": "Pengampunan"
  }
  },
  "preBismillah": null,
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat At Taubah terdiri atas 129 ayat termasuk golongan surat-surat Madaniyyah. Surat ini dinamakan At Taubah yang berarti pengampunan berhubung kata At Taubah berulang kali disebut dalam surat ini. Dinamakan juga dengan Baraah yang berarti berlepas diri yang di sini maksudnya pernyataan pemutusan perhubungan, disebabkan kebanyakan pokok pembicaraannya tentang pernyataan pemutusan perjanjian damai dengan kaum musyrikin.  Di samping kedua nama yang masyhur itu ada lagi beberapa nama yang lain yang merupakan sifat dari surat ini.  Berlainan dengan surat-surat yang lain, maka pada permulaan surat ini tidak terdapat basmalah, karena surat ini adalah pernyataan perang dengan arti bahwa segenap kaum muslimin dikerahkan untuk memerangi seluruh kaum musyrikin, sedangkan basmalah bernafaskan perdamaian dan cinta kasih Allah.  Surat ini diturunkan sesudah Nabi Muhammad s.a.w. kembali dari peperangan Tabuk yang terjadi pada tahun 9 H. Pengumuman ini disampaikan oleh Saidina 'Ali r.a. pada musim haji tahun itu juga.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/009.mp3"
  }
  },
  {
  "number": 10,
  "ayahCount": 109,
  "sequence": 51,
  "asma": {
  "ar": {
  "short": "يونس",
  "long": "سورة يونس"
  },
  "en": {
  "short": "Yunus",
  "long": "Sura Yunus"
  },
  "id": {
  "short": "Yunus",
  "long": "Surah Yunus"
  },
  "translation": {
  "en": "Jonas",
  "id": "Yunus"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Yunus terdiri atas 109 ayat, termasuk golongan surat-surat Makkiyyah kecuali ayat 40, 94, 95, yang diturunkan pada masa Nabi Muhmmad s.a.w. berada di Madinah. Surat ini dinamai surat Yunus karena dalam surat ini terutama ditampilkan kisah Nabi Yunus a.s. dan pengikut-pengikutnya yang teguh imannya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/010.mp3"
  }
  },
  {
  "number": 11,
  "ayahCount": 123,
  "sequence": 52,
  "asma": {
  "ar": {
  "short": "هود",
  "long": "سورة هود"
  },
  "en": {
  "short": "Hud",
  "long": "Sura Hud"
  },
  "id": {
  "short": "Hud",
  "long": "Surah Hud"
  },
  "translation": {
  "en": "Hud",
  "id": "Hud"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Huud termasuk golongan surat-surat Makkiyyah, terdiri dari 123 ayat diturunkan sesudah surat Yunus. Surat ini dinamai surat Huud karena ada hubungan dengan terdapatnya kisah Nabi Huud a.s. dan kaumnya dalam surat ini terdapat juga kisah-kisah Nabi yang lain, seperti kisah Nuh a.s., Shaleh a.s., Ibrahim a.s., Luth a.s., Syu'aib a.s. dan Musa a.s.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/011.mp3"
  }
  },
  {
  "number": 12,
  "ayahCount": 111,
  "sequence": 53,
  "asma": {
  "ar": {
  "short": "يوسف",
  "long": "سورة يوسف"
  },
  "en": {
  "short": "Yusuf",
  "long": "Sura Yusuf"
  },
  "id": {
  "short": "Yusuf",
  "long": "Surah Yusuf"
  },
  "translation": {
  "en": "Joseph",
  "id": "Yusuf"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Yusuf ini terdiri atas 111 ayat, termasuk golongan surat-surat Makkiyyah karena diturunkan di Mekah sebelum hijrah. Surat ini dinamakan surat Yusuf adalah karena titik berat dari isinya mengenai riwayat Nabi Yusuf a.s.  Riwayat tersebut salah satu di antara cerita-cerita ghaib yang diwahyukan kepada Nabi Muhammad s.a.w. sebagai mukjizat bagi beliau, sedang beliau sebelum diturunkan surat ini tidak mengetahuinya.  Menurut riwayat Al Baihaqi dalam kitab Ad Dalail bahwa segolongan orang Yahudi masuk agama Islam sesudah mereka mendengar cerita Yusuf a.s. ini, karena sesuai dengan cerita-cerita yang mereka ketahui. Dari cerita Yusuf a.s. ini, Nabi Muhammad s.a.w. mengambil pelajaran-pelajaran yang banyak dan merupakan penghibur terhadap beliau dalam menjalankan tugasnya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/012.mp3"
  }
  },
  {
  "number": 13,
  "ayahCount": 43,
  "sequence": 96,
  "asma": {
  "ar": {
  "short": "الرعد",
  "long": "سورة الرعد"
  },
  "en": {
  "short": "Ar-Ra'd",
  "long": "Sura Ar-Ra'd"
  },
  "id": {
  "short": "Ar-Ra'd",
  "long": "Surah Ar-Ra'd"
  },
  "translation": {
  "en": "The Thunder",
  "id": "Guruh"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Ar Ra'd ini terdiri atas 43 ayat termasuk golongan surat-surat Madaniyyah. Surat ini dinamakan Ar Ra'd yang berarti guruh karena dalam ayat 13 Allah berfirman yang artinya Dan guruh itu bertasbih sambil memuji-Nya, menunjukkan sifat kesucian dan kesempurnaan Allah s.w.t.  Dan lagi sesuai dengan sifat Al Quran yang mengandung ancaman dan harapan, maka demikian pulalah halnya bunyi guruh itu menimbulkan kecemasan dan harapan kepada manusia. Isi yang terpenting dari surat ini ialah bahwa bimbingan Allah kepada makhluk-Nya bertalian erat dengan hukum sebab dan akibat. Bagi Allah s.w.t. tidak ada pilih kasih dalam menetapkan hukuman. Balasan atau hukuman adalah akibat dan ketaatan atau keingkaran terhadap hukum Allah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/013.mp3"
  }
  },
  {
  "number": 14,
  "ayahCount": 52,
  "sequence": 72,
  "asma": {
  "ar": {
  "short": "ابراهيم",
  "long": "سورة ابراهيم"
  },
  "en": {
  "short": "Ibrahim",
  "long": "Sura Ibrahim"
  },
  "id": {
  "short": "Ibrahim",
  "long": "Surah Ibrahim"
  },
  "translation": {
  "en": "Abraham",
  "id": "Ibrahim"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ibrahim ini terdiri atas 52 ayat, termasuk golongan surat-surat Makkiyyah karena diturunkan di Mekah sebelum Hijrah. Dinamakan Ibrahim, karena surat ini mengandung doa Nabi Ibrahim a.s. yaitu ayat 35 sampai dengan 41. Do'a ini isinya antara lain: permohonan agar keturunannya mendirikan shalat, dijauhkan dari menyembah berhala-berhala dan agar Mekah dan daerah sekitarnya menjadi daerah yang aman dan makmur. Doa Nabi Ibrahim a.s. ini telah diperkenankan oleh Allah s.w.t. sebagaimana telah terbukti keamanannya sejak dahulu sampai sekarang. Do'a tersebut dipanjatkan beliau ke hadirat Allah s.w.t. sesudah selesai membina Ka'bah bersama puteranya Ismail a.s., di dataran tanah Mekah yang tandus.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/014.mp3"
  }
  },
  {
  "number": 15,
  "ayahCount": 99,
  "sequence": 54,
  "asma": {
  "ar": {
  "short": "الحجر",
  "long": "سورة الحجر"
  },
  "en": {
  "short": "Al-Hijr",
  "long": "Sura Al-Hijr"
  },
  "id": {
  "short": "Al-Hijr",
  "long": "Surah Al-Hijr"
  },
  "translation": {
  "en": "The Rock",
  "id": "Hijr"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 99 ayat, termasuk golongan surat-surat Makkiyyah,  karena diturunkan di Mekah sebelum hijrah. Al Hijr  adalah nama  sebuah daerah  pegunungan yang didiami zaman dahulu  oleh kaum  Tsamud terletak  di  pinggir  jalan antara Madinah dan Syam (Syria). Nama surat ini diambil dari nama daerah pegunungan itu, berhubung nasib  penduduknya yaitu  kaum Tsamud  diceritakan pada ayat  80 sampai  dengan 84,  mereka  telah  dimusnahkan Allah  s.w.t.,  karena  mendustakan  Nabi  Shaleh  a.s.  dan berpaling   dari ayat-ayat  Allah. Dalam  surat ini terdapat juga kisah-kisah  kaum yang lain yang telah dibinasakan oleh Allah seperti  kaum Luth  a.s. dan kaum Syu'aib a.s. Dari ke semua kisah-kisah  itu dapat  diambil pelajaran bahwa orang-orang  yang  menentang  ajaran  rasul-rasul  akan  mengalami kehancuran.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/015.mp3"
  }
  },
  {
  "number": 16,
  "ayahCount": 128,
  "sequence": 70,
  "asma": {
  "ar": {
  "short": "النحل",
  "long": "سورة النحل"
  },
  "en": {
  "short": "An-Nahl",
  "long": "Sura An-Nahl"
  },
  "id": {
  "short": "An-Nahl",
  "long": "Surah An-Nahl"
  },
  "translation": {
  "en": "The Bee",
  "id": "Lebah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 128 ayat, termasuk golongan surat-surat Makkiyyah. Surat ini dinamakan An Nahl yang berarti lebah karena di dalamnya, terdapat firman Allah s.w.t. ayat 68 yang artinya : \"Dan Tuhanmu mewahyukan kepada lebah.\" Lebah adalah makhluk Allah yang banyak memberi manfaat  dan kenikmatan kepada manusia. Ada persamaan antara madu yang dihasilkan oleh lebah dengan Al Quranul Karim. Madu berasal dari bermacam-macam sari bunga dan dia menjadi obat bagi bermacam-macam penyakit manusia (lihat ayat 69). Sedang Al Quran mengandung inti sari dari kitab-kitab yang telah diturunkan kepada Nabi-nabi zaman dahulu ditambah dengan ajaran-ajaran yang diperlukan oleh semua bangsa sepanjang masa untuk mencapai kebahagiaan dunia dan akhirat. (Lihat surat (10) Yunus ayat 57 dan surat (17) Al Isra' ayat  82). Surat ini dinamakan pula \"An Ni'am\" artinya nikmat-nikmat, karena di dalamnya Allah menyebutkan pelbagai macam nikmat untuk hamba-hamba-Nya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/016.mp3"
  }
  },
  {
  "number": 17,
  "ayahCount": 111,
  "sequence": 50,
  "asma": {
  "ar": {
  "short": "الإسراء",
  "long": "سورة الإسراء"
  },
  "en": {
  "short": "Al-Israa",
  "long": "Sura Al-Israa"
  },
  "id": {
  "short": "Al-Isra'",
  "long": "Surah Al-Isra'"
  },
  "translation": {
  "en": "The Night Journey",
  "id": "Memperjalankan Malam Hari"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 111 ayat, termasuk golongan surat-surat Makkiyyah. Dinamakan dengan Al Israa' yang berarti memperjalankan di malam hari, berhubung peristiwa Israa' Nabi Muhammad s.a.w. di Masjidil Haram di Mekah ke Masjidil Aqsha di Baitul Maqdis dicantumkan pada ayat pertama dalam surat ini. Penuturan cerita Israa' pada permulaan surat ini, mengandung isyarat bahwa Nabi Muhammad s.a.w. beserta umatnya kemudian hari akan mencapai martabat yang tinggi dan akan menjadi umat yang besar. Surat ini dinamakan pula dengan Bani Israil artinya keturunan Israil berhubung dengan permulaan surat ini, yakni pada ayat kedua sampai dengan ayat kedelapan dan kemudian dekat akhir surat yakni pada ayat 101 sampai dengan ayat 104, Allah menyebutkan tentang Bani Israil yang setelah menjadi bangsa yang kuat lagi besar lalu menjadi bangsa yang terhina karena menyimpang dari ajaran Allah s.w.t. Dihubungkannya kisah Israa' dengan riwayat Bani Israil pada surat ini, memberikan peringatan bahwa umat Islam akan mengalami keruntuhan, sebagaimana halnya Bani Israil, apabila mereka juga meninggalkan ajaran-ajaran agamanya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/017.mp3"
  }
  },
  {
  "number": 18,
  "ayahCount": 110,
  "sequence": 69,
  "asma": {
  "ar": {
  "short": "الكهف",
  "long": "سورة الكهف"
  },
  "en": {
  "short": "Al-Kahf",
  "long": "Sura Al-Kahf"
  },
  "id": {
  "short": "Al-Kahf",
  "long": "Surah Al-Kahf"
  },
  "translation": {
  "en": "The Cave",
  "id": "Goa"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat  ini terdiri atas 110 ayat, termasuk  golongan  surat-surat Makkiyyah. Dinamai Al-Kahfi artinya Gua dan Ashhabul Kahfi yang artinya Penghuni-Penghuni Gua. Kedua nama ini diambil dari cerita yang terdapat dalam surat ini pada ayat 9 sampai dengan 26, tentang beberapa orang pemuda yang tidur dalam gua bertahun-tahun lamanya. Selain cerita tersebut, terdapat pula beberapa buah cerita dalam surat ini, yang kesemuanya mengandung i'tibar dan pelajaran-pelajaran yang amat berguna bagi kehidupan manusia. Banyak hadist-hadist Rasulullah s.a.w. yang menyatakan keutamaan membaca surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/018.mp3"
  }
  },
  {
  "number": 19,
  "ayahCount": 98,
  "sequence": 44,
  "asma": {
  "ar": {
  "short": "مريم",
  "long": "سورة مريم"
  },
  "en": {
  "short": "Maryam",
  "long": "Sura Maryam"
  },
  "id": {
  "short": "Maryam",
  "long": "Surah Maryam"
  },
  "translation": {
  "en": "Mary",
  "id": "Maryam"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Maryam terdiri atas 98 ayat, termasuk golongan surat-surat Makkiyyah, karena hampir seluruh ayatnya diturunkan sebelum Nabi Muhammad s.a.w. hijrah ke Madinah, bahkan sebelum sahabat-sahabat beliau hijrah ke negeri Habsyi. Menurut riwayat Ibnu Mas'ud, Ja'far bin Abi Thalib membacakan permulaan surat Maryam ini kepada raja Najasyi dan pengikut-pengikutnya di waktu ia ikut hijrah bersama-sama sahabat-sahabat yang lain ke negeri Habsyi.Surat ini dinamai Maryam, karena surat ini mengandung kisah Maryam, ibu Nabi Isa a.s. yang serba ajaib, yaitu melahirkan puteranya lsa a.s., sedang ia sebelumnya belum pernah dikawini atau dicampuri oleh seorang laki-laki pun. Kelahiran Isa a.s. tanpa bapa, merupakan suatu bukti kekuasaan Allah s.w.t.  Pengutaraan kisah Maryam sebagai kejadian yang luar biasa dan ajaib dalam surat ini, diawali dengan kisah kejadian yang luar biasa dan ajaib pula, yaitu dikabulkannya doa Zakaria a.s. oleh Allah s.w.t., agar beliau dianugerahi seorang putera sebagai pewaris dan pelanjut cita-cita dan kepercayaan beliau, sedang usia beliau sudah sangat tua dan isteri beliau seorang yang mandul yang menurut ukuran ilmu biologi tidak mungkin akan terjadi.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/019.mp3"
  }
  },
  {
  "number": 20,
  "ayahCount": 135,
  "sequence": 45,
  "asma": {
  "ar": {
  "short": "طه",
  "long": "سورة طه"
  },
  "en": {
  "short": "Taa-Haa",
  "long": "Sura Taa-Haa"
  },
  "id": {
  "short": "Taha",
  "long": "Surah Taha"
  },
  "translation": {
  "en": "Taa-Haa",
  "id": "Taha"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Thaahaa terdiri atas 135 ayat, diturunkan sesudah diturunkannya surat Maryam, termasuk golongan surat-surat Makkiyyah. Surat ini dinamai Thaahaa, diambil dari perkataan yang berasal dan ayat pertama surat ini. Sebagaimana yang lazim terdapat pada surat-surat yang memakai huruf-huruf abjad pada permulaannya, di mana huruf tersebut seakan-akan merupakan pemberitahuan Allah kepada orang-orang yang membacanya, bahwa sesudah huruf itu akan dikemukakan hal-hal yang  sangat penting diketahui, maka demikian pula halnya dengan ayat-ayat yang terdapat sesudah huruf thaahaa dalam surat ini. Allah menerangkan bahwa Al Quran merupakan peringatan bagi manusia, wahyu dari Allah, Pencipta semesta alam. Kemudian Allah menerangkan kisah beberapa orang nabi; akibat-akibat yang telah ada akan dialami oleh orang-orang yang percaya kepada Allah dan orang-orang yang mengingkari-Nya, baik di dunia maupun di akhirat. Selain hal-hal tersebut di atas, maka surat ini mengandung pokok-pokok isi sebagai berikut:",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/020.mp3"
  }
  },
  {
  "number": 21,
  "ayahCount": 112,
  "sequence": 73,
  "asma": {
  "ar": {
  "short": "الأنبياء",
  "long": "سورة الأنبياء"
  },
  "en": {
  "short": "Al-Anbiyaa",
  "long": "Sura Al-Anbiyaa"
  },
  "id": {
  "short": "Al-Anbiya'",
  "long": "Surah Al-Anbiya'"
  },
  "translation": {
  "en": "The Prophets",
  "id": "Para Nabi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Anbiyaa' yang terdiri atas 112 ayat, termasuk golongan surat Makkiyyah. Dinamai surat ini dengan al anbiyaa'(nabi-nabi), karena surat ini mengutarakan kisah beberapa orang nabi. Permulaan surat Al Anbiyaa' menegaskan bahwa manusia lalai dalam menghadapi hari berhisab, kemudian berhubung adanya pengingkaran kaum musyrik Mekah terhadap wahyu yang dibawa Nabi Muhammad s.a.w. maka ditegaskan Allah, kendatipun nabi-nabi itu manusia biasa, akan tetapi masing-masing mereka adalah manusia yang membawa wahyu yang pokok ajarannya adalah tauhid, dan keharusan manusia menyembah Allah Tuhan Penciptanya. Orang yang tidak mau mengakui kekuasaan Allah dan mengingkari ajaran yang dibawa oleh nabi-nabi itu, akan diazab Allah didunia dan di akhirat nanti. Kemudian dikemukakan kisah beberapa orang nabi dengan umatnya. Akhirnya surat itu ditutup dengan seruan agar kaum musyrik Mekah percaya kepada ajaran yang dibawa Muhammad s.a.w supaya tidak mengalami apa yang telah dialami oleh umat-umat yang dahulu.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/021.mp3"
  }
  },
  {
  "number": 22,
  "ayahCount": 78,
  "sequence": 103,
  "asma": {
  "ar": {
  "short": "الحج",
  "long": "سورة الحج"
  },
  "en": {
  "short": "Al-Hajj",
  "long": "Sura Al-Hajj"
  },
  "id": {
  "short": "Al-Hajj",
  "long": "Surah Al-Hajj"
  },
  "translation": {
  "en": "The Pilgrimage",
  "id": "Haji"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Hajj, termasuk golongan surat-surat Madaniyyah, terdiri atas 78 ayat, sedang menurut pendapat sebahagian ahli tafsir termasuk golongan surat-surat Makkiyah. Sebab perbedaan ini ialah karena sebahagian ayat-ayat surat ini ada yang diturunkan di Mekah dan sebahagian lagi diturunkan di Madinah. Dinamai surat ini Al Hajj, karena surat ini mengemukakan hal-hal yang berhubungan dengan ibadat haji, seperti ihram, thawaf, sa'i, wuquf di Arafah, mencukur rambut, syi'ar-syi'ar Allah, faedah-faedah dan hikmah-hikmah disyari'atkannya haji. Ditegaskan pula bahwa ibadat haji itu telah disyari'atkan di masa Nabi Ibrahim a.s., dan Ka'bah didirikan oleh Nabi Ibrahim a.s. bersama puteranya Ismail a.s.Menurut Al Ghaznawi, surat Al Hajj termasuk di antara surat- surat yang ajaib, diturunkan di malam dan di siang hari, dalam musafir dan dalam keadaan tidak musafir, ada ayat-ayat yang diturunkan di Mekah dan ada pula yang diturunkan di Madinah, isinya ada yang berhubungan dengan peperangan dan ada pula yang berhubungan dengan perdamaian, ada ayat-ayatnya yang muhkam dan ada pula yang mutasyabihaat.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/022.mp3"
  }
  },
  {
  "number": 23,
  "ayahCount": 118,
  "sequence": 74,
  "asma": {
  "ar": {
  "short": "المؤمنون",
  "long": "سورة المؤمنون"
  },
  "en": {
  "short": "Al-Muminoon",
  "long": "Sura Al-Muminoon"
  },
  "id": {
  "short": "Al-Mu'minun",
  "long": "Surah Al-Mu'minun"
  },
  "translation": {
  "en": "The Believers",
  "id": "Orang-Orang Mukmin"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Mu'minuun terdiri atas 118 ayat, termasuk golongan surat-surat Makkiyyah. Dinamai Al Mu'minuun, karena permulaan ayat ini manerangkan bagaimana seharusnya sifat-sifat orang mukmin yang menyebabkan keberuntungan mereka di akhirat dan ketenteraman jiwa mereka di dunia. Demikian tingginya sifat-sifat itu, hingga ia telah menjadi akhlak bagi Nabi Muhammad s.a.w.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/023.mp3"
  }
  },
  {
  "number": 24,
  "ayahCount": 64,
  "sequence": 102,
  "asma": {
  "ar": {
  "short": "النور",
  "long": "سورة النور"
  },
  "en": {
  "short": "An-Noor",
  "long": "Sura An-Noor"
  },
  "id": {
  "short": "An-Nur",
  "long": "Surah An-Nur"
  },
  "translation": {
  "en": "The Light",
  "id": "Cahaya"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat An Nuur terdiri atas 64 ayat, dan termasuk golongan surat-surat Madaniyah. Dinamai An Nuur yang berarti Cahaya, diambil dari kata An Nuur yang terdapat pada ayat ke 35. Dalam ayat ini, Allah s.w.t. menjelaskan tentang Nuur Ilahi, yakni Al Quran yang mengandung petunjuk-petunjuk. Petunjuk-petunjuk Allah itu, merupakan cahaya yang terang benderang menerangi alam semesta. Surat ini sebagian besar isinya memuat petunjuk- petunjuk Allah yang berhubungan dengan soal kemasyarakatan dan rumah tangga.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/024.mp3"
  }
  },
  {
  "number": 25,
  "ayahCount": 77,
  "sequence": 42,
  "asma": {
  "ar": {
  "short": "الفرقان",
  "long": "سورة الفرقان"
  },
  "en": {
  "short": "Al-Furqaan",
  "long": "Sura Al-Furqaan"
  },
  "id": {
  "short": "Al-Furqan",
  "long": "Surah Al-Furqan"
  },
  "translation": {
  "en": "The Criterion",
  "id": "Pembeda"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 77 ayat, termasuk golongan surat-surat Makkiyah. Dinamai Al Furqaan yang artinya pembeda, diambil dari kata Al Furqaan yang terdapat pada ayat pertama surat ini. Yang dimaksud dengan Al Furqaan dalam ayat ini ialah Al Quran. Al Quran dinamakan Al Furqaan karena dia membedakan antara yang haq dengan yang batil. MAka pada surat ini pun terdapat ayat-ayat yang membedakan antara kebenaran ke-esaan Allah s.w.t. dengan kebatilan kepercayaan syirik.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/025.mp3"
  }
  },
  {
  "number": 26,
  "ayahCount": 227,
  "sequence": 47,
  "asma": {
  "ar": {
  "short": "الشعراء",
  "long": "سورة الشعراء"
  },
  "en": {
  "short": "Ash-Shu'araa",
  "long": "Sura Ash-Shu'araa"
  },
  "id": {
  "short": "Asy-Syu'ara'",
  "long": "Surah Asy-Syu'ara'"
  },
  "translation": {
  "en": "The Poets",
  "id": "Para Penyair"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri dari 227 ayat termasuk golongan surat-surat Makkiyyah. Dinamakan Asy Syu'araa' (kata jamak dari Asy Syaa'ir yang berarti penyair) diambil dari kata Asy Syuaraa' yang terdapat pada ayat 224, yaitu pada bagian terakhir surat ini, di kala Allah s.w.t. secara khusus menyebutkan kedudukan penyair- penyair. Para penyair-penyair itu mempunyai sifat-sifat yang jauh berbeda dengan para rasul-rasul; mereka diikuti oleh orang-orang yang sesat dan mereka suka memutar balikkan lidah dan mereka tidak mempunyai pendirian, perbuatan mereka tidak sesuai dengan tidak mempunyai pendirian, perbuatan mereka tidak sesuai dengan apa yang mereka ucapkan. Sifat-sifat yang demikian tidaklah sekali-kali terdapat pada rasul-rasul. Oleh karena demikian tidak patut bila Nabi Muhammad s.a.w. dituduh sebagai penyair, dan Al Quran dituduh sebagai syair, Al Quran adalah wahyu Allah, bukan buatan manusia.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/026.mp3"
  }
  },
  {
  "number": 27,
  "ayahCount": 93,
  "sequence": 48,
  "asma": {
  "ar": {
  "short": "النمل",
  "long": "سورة النمل"
  },
  "en": {
  "short": "An-Naml",
  "long": "Sura An-Naml"
  },
  "id": {
  "short": "An-Naml",
  "long": "Surah An-Naml"
  },
  "translation": {
  "en": "The Ant",
  "id": "Semut-semut"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat An Naml terdiri atas 98 ayat, termasuk golongan surat- surat Makkiyyah dan diturunkan sesudah surat Asy Syu'araa'. Dinamai dengan An Naml, karena pada ayat 18 dan 19 terdapat perkataan An Naml (semut), di mana raja semut mengatakan kepada anak buahnya agar masuk sarangnya masing-masing, supaya jangan terpijak oleh Nabi Sulaiman a.s. dan tentaranya yang akan lalu di tempat itu. Mendengar perintah raja semut kepada anak buahnya itu, Nabi Sulaiman tersenyum dan ta'jub atas keteraturan kerajaan semut itu dan beliau mengucapkan syukur kepada Tuhan Yang Maba Kuasa yang telah melimpahkan nikmat kepadanya, berupa kerajaan, kekayaan, memahami ucapan-ucapan binatang, mempunyai tentara yang terdiri atas jin, manusia, burung dan sebagainya. Nabi Sulaiman a.s. yang telah diberi Allah nikmat yang besar itu tidak merasa takabur dan sombong dan sebagai seorang hamba Allah mohon agar Allah memasukkannya ke dalam golongan orang-orang yang saleh. Allah s.w.t. menyebut binatang semut dalam surat ini agar manusia mengambil pelajaran dari kehidupan semut itu. Semut adalah binatang yang hidup berkelompok di dalam tanah, membuat liang dan ruang yang bertingkat-tingkat sebagai rumah dan gudang tempat menyimpan makanan musim dingin. Kerapian dan kedisiplinan yang terdapat dalam kerajaan semut ini, dinyatakan Allah dalam ayat ini dengan bagaimana rakyat semut mencari perlindungan segera agar jangan terpijak oleh Nabi Sulaiman a.s dan tentaranya, setelah menerima peringatan dari rajanya. Secara tidak langsung Allah mengingatkan juga kepada manusia agar dalam berusaha untuk mencukupkan kebutuhan sehari-hari, mementingkan pula kemaslahatan bersama dan sebagainya, rakyat semut mempunyai organisasi dan kerja sama yang baik pula. Dengan mengisahkan kisah Nabi Sulaiman a.s. dalam surat ini Allah mengisyaratkan hari depan dan kebesaran Nabi Muhammad s.a.w. Nabi Sulaiman a.s. sebagai seorang nabi, rasul dan raja yang dianugerahi kekayaan yang melimpah ruah, begitu pula Nabi Muhammad s.a.w. sebagai seorang nabi, rasul dan seoramg kepala negara yang ummi' dan miskin akan berhasil membawa dan memimpin umatnya ke jalan Allah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/027.mp3"
  }
  },
  {
  "number": 28,
  "ayahCount": 88,
  "sequence": 49,
  "asma": {
  "ar": {
  "short": "القصص",
  "long": "سورة القصص"
  },
  "en": {
  "short": "Al-Qasas",
  "long": "Sura Al-Qasas"
  },
  "id": {
  "short": "Al-Qasas",
  "long": "Surah Al-Qasas"
  },
  "translation": {
  "en": "The Stories",
  "id": "Kisah-Kisah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Qashash terdiri atas 88 ayat termasuk golongan surat-surat Makkiyyah. Dinamai dengan Al Qashash, karena pada ayat 25 surat ini terdapat kata Al Qashash yang berarti cerita. Ayat ini menerangkan bahwa setelah Nabi Musa a.s. bertemu dengan Nabi Syua'ib a.s. ia menceritakan cerita yang berhubungan  dengan dirinya sendiri, yakni pengalamannya dengan Fir'aun, sampai waktu ia diburu oleh Fir'aun karena membunuh seseorang dari bangsa Qibthi tanpa disengaja, Syua'ib a.s. menjawab bahwa Musa a.s. telah selamat dari pengejaran  orang-orang zalim. Turunnya ayat 25 surat ini amat besar artinya bagi Nabi Muhammad s.a.w. dan bagi sahabat-sahabat yang melakukan hijrah ke Madinah, yang menambah keyakinan mereka, bahwa akhirnya orang-orang Islamlah yang menang, sebab ayat ini menunjukkan bahwa barangsiapa yang berhijrah dari tempat musuh untuk mempertahankan keimanan, pasti akan berhasil dalam perjuangannya menghadapi musuh-musuh agama. Kepastian kemenangan bagi kaum muslimin itu, ditegaskan pada bagian akhir surat ini yang mengandung bahwa setelah hijrah ke Madinah kaum muslimin akan kembali ke Mekah sebagai pemenang dan penegak agama Allah. Surat Al Qashash ini adalah surat yang paling lengkap memuat cerita Nabi Musa a.s. sehingga menurut suatu riwayat, surat ini dinamai juga dengan surat Musa.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/028.mp3"
  }
  },
  {
  "number": 29,
  "ayahCount": 69,
  "sequence": 85,
  "asma": {
  "ar": {
  "short": "العنكبوت",
  "long": "سورة العنكبوت"
  },
  "en": {
  "short": "Al-Ankaboot",
  "long": "Sura Al-Ankaboot"
  },
  "id": {
  "short": "Al-'Ankabut",
  "long": "Surah Al-'Ankabut"
  },
  "translation": {
  "en": "The Spider",
  "id": "Laba-Laba"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al 'Ankabuut terdiri atas 69 ayat, termasuk golongan surat-surrat Makkiyah. Dinamai Al 'Ankabuut berhubung terdapatnya perkataan Al 'Ankabuut yang berarti laba-laba pada ayat 41 surat ini, dimana Allah mengumpamakan penyembah-penyembah berhala-berhala itu, dengan laba-laba yang percaya kepada kekuatan rumahnya sebagai tempat ia berlindung dan tempat ia menjerat mangsanya, padahal kalau dihembus angin atau ditimpa oleh suatu barang yang kecil saja, rumah itu akan hancur. Begitu pula halnya dengan kaum musyrikin yang percaya kepada kekuatan sembahan-sembahan mereka sebagai tempat berlindung dan tempat meminta sesuatu yang mereka ingini, padahal sembahan-sembahan mereka itu tidak mampu sedikit juga menolong mereka dari azab Allah waktu di dunia, seperti yang terjadi pada kaum Nuh, kaum Ibrahim, kaum Luth, kaum Syu'aib, kaum Saleh, dan lain-lain. Apalagi menghadapi azab Allah di akhirat nanti, sembahan-sembahan mereka itu lebih tidak mampu menghindarkan dan melindungi mereka.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/029.mp3"
  }
  },
  {
  "number": 30,
  "ayahCount": 60,
  "sequence": 84,
  "asma": {
  "ar": {
  "short": "الروم",
  "long": "سورة الروم"
  },
  "en": {
  "short": "Ar-Room",
  "long": "Sura Ar-Room"
  },
  "id": {
  "short": "Ar-Rum",
  "long": "Surah Ar-Rum"
  },
  "translation": {
  "en": "The Romans",
  "id": "Romawi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ar Ruum terdiri atas 60 ayat, termasuk golongan surat-surat Makkiyah diturunkan sesudah ayat Al Insyiqaq. Dinamakan Ar Ruum karena pada permulaan surat ini, yaitu ayat 2, 3 dan 4 terdapat pemberitaan bangsa Rumawi yang pada mulanya dikalahkan oleh bangsa Persia, tetapi setelah beberapa tahun kemudian kerajaan Ruum dapat menuntut balas dan mengalahkan kerajaan Persia kembali. Ini adalah suatu mukjizat Al Quran, yaitu memberitakan hal-hal yang akan terjadi di masa yang akan datang. Dan juga suatu isyarat bahwa kaum muslimin yang demikian lemahnya di waktu itu akan menang dan dapat menghancurkan kaum musyrikin. Isyarat ini terbukti pertama kali pada perang Badar.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/030.mp3"
  }
  },
  {
  "number": 31,
  "ayahCount": 34,
  "sequence": 57,
  "asma": {
  "ar": {
  "short": "لقمان",
  "long": "سورة لقمان"
  },
  "en": {
  "short": "Luqman",
  "long": "Sura Luqman"
  },
  "id": {
  "short": "Luqman",
  "long": "Surah Luqman"
  },
  "translation": {
  "en": "Luqman",
  "id": "Luqman"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat  Luqman  terdiri   dari   34   ayat,   termasuk   golongan   surat-surat Makkiyyah, diturunkan sesudah surat Ash Shaffaat. Dinamai Luqman karena pada  ayat  12   disebutkan   bahwa   Luqman   telah diberi   oleh   Allah   nikmat   dan   ilmu   pengetahuan,  oleh sebab itu dia bersyukur kepadaNya atas nikmat yang  diberikan  itu.   Dan   pada   ayat   13 sampai 19 terdapat nasihat-nasihat Luqman kepada anaknya.Ini adalah sebagai  isyarat   daripada   Allah   supaya   setiap   ibu   bapak melaksanakan  pula terhadap anak-anak mereka sebagai yang telah dilakukan oleh Luqman.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/031.mp3"
  }
  },
  {
  "number": 32,
  "ayahCount": 30,
  "sequence": 75,
  "asma": {
  "ar": {
  "short": "السجدة",
  "long": "سورة السجدة"
  },
  "en": {
  "short": "As-Sajda",
  "long": "Sura As-Sajda"
  },
  "id": {
  "short": "As-Sajdah",
  "long": "Surah As-Sajdah"
  },
  "translation": {
  "en": "The Prostration",
  "id": "Sajdah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat As Sajdah terdiri atas 30 ayat termasuk golongan surat Makkiyah diturunkan sesudah surat Al Mu'minuun. Dinamakan As Sajdah berhubung pada surat ini terdapat ayat sajdah, yaitu ayat yang kelima belas.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/032.mp3"
  }
  },
  {
  "number": 33,
  "ayahCount": 73,
  "sequence": 90,
  "asma": {
  "ar": {
  "short": "الأحزاب",
  "long": "سورة الأحزاب"
  },
  "en": {
  "short": "Al-Ahzaab",
  "long": "Sura Al-Ahzaab"
  },
  "id": {
  "short": "Al-Ahzab",
  "long": "Surah Al-Ahzab"
  },
  "translation": {
  "en": "The Clans",
  "id": "Golongan Yang Bersekutu"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Ahzab terdiri atas 73 ayat, termasuk golongan surat-surat Madaniyah, diturunkan sesudah surat Ali'Imran. Dinamai Al Ahzab yang berarti golongan-golongan yang bersekutu karena dalam surat ini terdapat beberapa ayat, yaitu ayat 9 sampai dengan ayat 27 yang berhubungan dengan peperangan Al Ahzab, yaitu peperangan yang dilancarkan oleh orang-orang Yahudi, kaum munafik dan orang-orang musyrik terhadap orang-orang mukmin di Medinah. Mereka telah mengepung rapat orang- orang mukmin sehingga sebahagian dari mereka telah berputus asa dan menyangka bahwa mereka akan dihancurkan oleh musuh-musuh mereka itu. Ini adalah suatu ujian yang berat dari Allah untuk menguji sampai dimana teguhnya keimanan mereka. Akhirnya Allah mengirimkan bantuan berupa tentara yang tidak kelihatan dan angin topan, sehingga musuh-musuh itu menjadi kacau balau dan melarikan diri.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/033.mp3"
  }
  },
  {
  "number": 34,
  "ayahCount": 54,
  "sequence": 58,
  "asma": {
  "ar": {
  "short": "سبإ",
  "long": "سورة سَبَأ"
  },
  "en": {
  "short": "Saba",
  "long": "Sura Saba"
  },
  "id": {
  "short": "Saba'",
  "long": "Surah Saba'"
  },
  "translation": {
  "en": "Sheba",
  "id": "Saba'"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Saba' terdiri atas 54 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Luqman. Dinamakan Saba' karena didalamnya terdapat kisah kaum Saba'. Saba' adalah nama suatu kabilah dari kabilah-kabilah Arab yang tinggal di daerah Yaman sekarang ini. Mereka mendirikan kerajaan yang terkenal dengan nama kerajaan Sabaiyyah, ibukotanya Ma'rib; telah dapat membangun suatu bendungan raksasa, yang bernama Bendungan Ma'rib, sehingga negeri meka subur dan makmur. Kemewahan dan kemakmuran ini menyebabkan kaum Saba' lupa dan ingkar kepada Allah yang telah melimpahkan nikmatnya kepada mereka, serta mereka mengingkari pula seruan para rasul. Karena keingkaran mereka ini, Allah menimpahkan kepada mereka azab berupa sailul 'arim (banjir yang besar) yang ditimbulkan oleh bobolnya bendungan Ma'rib. Setelah bendungan ma'rib bobol negeri Saba' menjadi kering dan kerajaan mereka hancur.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/034.mp3"
  }
  },
  {
  "number": 35,
  "ayahCount": 45,
  "sequence": 43,
  "asma": {
  "ar": {
  "short": "فاطر",
  "long": "سورة فاطر"
  },
  "en": {
  "short": "Faatir",
  "long": "Sura Faatir"
  },
  "id": {
  "short": "Fatir",
  "long": "Surah Fatir"
  },
  "translation": {
  "en": "The Originator",
  "id": "Maha Pencipta"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Faathir terdiri atas 45 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Furqaan dan merupakan surat akhir dari urutan surat-surat dalam Al Quran yang dimulai dengan Alhamdulillah. Dinamakan Faathir (pencipta) ada hubungannya dengan perkataan Faathir yang terdapat pada ayat pertama pada surat ini. Pada ayat tersebut diterangkan bahwa Allah adalah Pencipta langit dan bumi, Pencipta malaikat-malaikat, Pencipta semesta alam yang semuanya itu adalah sebagai bukti atas kekuasaan dan kebesaran-Nya. Surat ini dinamai juga dengan surat Malaikat karena pada ayat pertama disebutkan bahwa Allah telah menjadikan malaikat-malaikat sebagai utusan-Nya  yang mempunyai beberapa sayap.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/035.mp3"
  }
  },
  {
  "number": 36,
  "ayahCount": 83,
  "sequence": 41,
  "asma": {
  "ar": {
  "short": "يس",
  "long": "سورة يس"
  },
  "en": {
  "short": "Yaseen",
  "long": "Sura Yaseen"
  },
  "id": {
  "short": "Yasin",
  "long": "Surah Yasin"
  },
  "translation": {
  "en": "Yaseen",
  "id": "Yasin"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Yaasiin terdiri atas 83 ayat, termasuk golongan surat-surat Makkiyyah,  diturunkan sesudah surat Jin. Dinamai Yaasiin karena dimulai dengan huruf Yaasiin. Sebagaimana halnya arti huruf-huruf abjad yang terletak pada permulaan beberapa surat Al Quran, maka demikian pula arti Yaasiin yang terdapat pada ayat permulaan surat ini, yaitu Allah mengisyaratkan bahwa sesudah huruf tersebut akan dikemukakan hal-hal yang penting antara lain: Allah bersumpah dengan Al Quran bahwa Muhammad s.a.w. benar-benar seorang rasul yang diutus-Nya kepada kaum yang belum pernah diutus kepada mereka rasul-rasul.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/036.mp3"
  }
  },
  {
  "number": 37,
  "ayahCount": 182,
  "sequence": 56,
  "asma": {
  "ar": {
  "short": "الصافات",
  "long": "سورة الصافات"
  },
  "en": {
  "short": "As-Saaffaat",
  "long": "Sura As-Saaffaat"
  },
  "id": {
  "short": "As-Saffat",
  "long": "Surah As-Saffat"
  },
  "translation": {
  "en": "Those drawn up in Ranks",
  "id": "Barisan-Barisan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ash Shaaffaat terdiri atas 182 ayat termasuk golongan surat Makkiyyah diturunkan sesudah surat Al An'aam. Dinamai dengan Ash Shaaffaat (yang bershaf-shaf) ada hubungannya dengan perkataan Ash Shaaffaat yang terletak pada ayat permulaan surat ini yang mengemukakan bagaimana para malaikat yang berbaris di hadapan Tuhannya yang bersih jiwanya, tidak dapat digoda oleh syaitan. Hal ini hendaklah menjadi i'tibar bagi manusia dalam menghambakan dirinya kepada Allah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/037.mp3"
  }
  },
  {
  "number": 38,
  "ayahCount": 88,
  "sequence": 38,
  "asma": {
  "ar": {
  "short": "ص",
  "long": "سورة ص"
  },
  "en": {
  "short": "Saad",
  "long": "Sura Saad"
  },
  "id": {
  "short": "Sad",
  "long": "Surah Sad"
  },
  "translation": {
  "en": "The letter Saad",
  "id": "Sad"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Shaad  terdiri atas  88 ayat  termasuk golongan  surat Makkiyyah, diturunkan sesudah surat Al Qamar. Dinamai  dengan  Shaad  karena surat  ini  dimulai  dengan Shaad (selanjutnya lihat no. [10)). Dalam surat  ini Allah  bersumpah dengan  Al Quran,   untuk menunjukkan bahwa Al Quran itu suatu  kitab yang  agung dan bahwa siapa saja yang  mengikutinya  akan mendapat  kebahagiaan  dunia  dan akhirat dan untuk menunjukkan bahwa Al Quran ini adalah mukjizat Nabi Muhammad s.a.w. yang  menyatakan kebenarannya dan ketinggian akhlaknya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/038.mp3"
  }
  },
  {
  "number": 39,
  "ayahCount": 75,
  "sequence": 59,
  "asma": {
  "ar": {
  "short": "الزمر",
  "long": "سورة الزمر"
  },
  "en": {
  "short": "Az-Zumar",
  "long": "Sura Az-Zumar"
  },
  "id": {
  "short": "Az-Zumar",
  "long": "Surah Az-Zumar"
  },
  "translation": {
  "en": "The Groups",
  "id": "Rombongan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Az Zumar terdiri ataz 75 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Saba'. Dinamakan Az Zumar (Rombongan-rombongan) karena perkataan Az Zumar yang terdapat pada ayat 71 dan 73 ini. Dalam ayat-ayat tersebut diterangkan keadaan manusia di hari kiamat setelah mereka dihisab, di waktu itu mereka terbagi atas dua rombongan; satu rombongan dibawa ke neraka dan satu rombongan lagi dibawa ke syurga. Masing- masing rombongan memperoleh balasan dari apa yang mereka kerjakan di dunia dahulu. Surat ini dinamakan juga Al Ghuraf (kamar-kamar) berhubung perkataan ghuraf yang terdapat pada ayat 20, dimana diterangkan keadaan kamar-kamar dalam syurga yang diperoleh orang-orang yang bertakwa.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/039.mp3"
  }
  },
  {
  "number": 40,
  "ayahCount": 85,
  "sequence": 60,
  "asma": {
  "ar": {
  "short": "غافر",
  "long": "سورة غافر"
  },
  "en": {
  "short": "Ghafir",
  "long": "Sura Ghafir"
  },
  "id": {
  "short": "Gafir",
  "long": "Surah Gafir"
  },
  "translation": {
  "en": "The Forgiver",
  "id": "Maha Pengampun"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Mu'min terdiri atas 85 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Az Zumar. Dinamai Al Mu'min (Orang yang beriman), berhubung dengan perkataan mukmin yang terdapat pada ayat 28 surat ini. Pada ayat 28 diterangkan bahwa salah seorang dari kaum Fir'aun telah beriman kepada Nabi Musa a.s. dengan menyembunyikan imannya kepada kaumnya, setelah mendengar keterangan dan melihat mukjizat yang dikemukakan oleh Nabi Musa a.s. Hati kecil orang ini mencela Fir'aun dan kaumnya yang tidak mau beriman kepada Nabi Musa a.s., sekalipun telah dikemukakan keterangan dan mukjizat yang diminta mereka.Dinamakan pula Ghafir (yang mengampuni), karena ada hubungannya dengan kalimat Ghafir yang terdapat pada ayat 3 surat ini. Ayat ini mengingatkan bahwa Maha Pengampun dan Maha Penerima Taubat adalah sebagian dari sifat-sifat Allah, karena itu hamba-hamba Allah tidak usah khawatir terhadap  perbuatan-perbuatan dosa yang telah terlanjur mereka lakukan, semuanya itu akan diampuni Allah asal benar-benar memohon ampun dan bertaubat kepada-Nya dan berjanji tidak akan mengerjakan  perbuatan-perbuatan dosa itu lagi. Dan surat ini dinamai Dzit Thaul (Yang Mempunyai Kurnia) karena perkataan tersebut terdapat pada ayat 3.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/040.mp3"
  }
  },
  {
  "number": 41,
  "ayahCount": 54,
  "sequence": 61,
  "asma": {
  "ar": {
  "short": "فصلت",
  "long": "سورة فصلت"
  },
  "en": {
  "short": "Fussilat",
  "long": "Sura Fussilat"
  },
  "id": {
  "short": "Fussilat",
  "long": "Surah Fussilat"
  },
  "translation": {
  "en": "Explained in detail",
  "id": "Yang Dijelaskan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Fushshilat terdiri atas 54 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Mu'min. Dinamai Fushshilat (yang dijelaskan) karena ada hubungannya dengan perkataan Fushshilat yang terdapat pada permulaan surat ini yang berarti yang dijelaskan. Maksudnya ayat-ayatnya diperinci dengan jelas tentang hukum-hukum, keimanan, janji dan ancaman, budi pekerti, kisah, dan sebagainya. Dinamai juga dengan Haa Miim dan As Sajdah karena surat ini dimulai dengan Haa Miim dan dalam surat ini terdapat ayat Sajdah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/041.mp3"
  }
  },
  {
  "number": 42,
  "ayahCount": 53,
  "sequence": 62,
  "asma": {
  "ar": {
  "short": "الشورى",
  "long": "سورة الشورى"
  },
  "en": {
  "short": "Ash-Shura",
  "long": "Sura Ash-Shura"
  },
  "id": {
  "short": "Asy-Syura",
  "long": "Surah Asy-Syura"
  },
  "translation": {
  "en": "Consultation",
  "id": "Musyawarah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Asy Syuura terdiri atas 53 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Fushshilat. Dinamai dengan Asy Syuura (musyawarat) diambil dari perkataan Syuura yang terdapat pada ayat 38 surat ini. Dalam ayat tersebut diletakkan salah satu dari dasar-dasar pemerintahan Islam ialah musyawarat. Dinamai juga Haa Miim 'Ain Siin Qaaf karena surat ini dimulai dengan huruf-huruf hijaiyah itu.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/042.mp3"
  }
  },
  {
  "number": 43,
  "ayahCount": 89,
  "sequence": 63,
  "asma": {
  "ar": {
  "short": "الزخرف",
  "long": "سورة الزخرف"
  },
  "en": {
  "short": "Az-Zukhruf",
  "long": "Sura Az-Zukhruf"
  },
  "id": {
  "short": "Az-Zukhruf",
  "long": "Surah Az-Zukhruf"
  },
  "translation": {
  "en": "Ornaments of gold",
  "id": "Perhiasan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Az Zukhruf terdiri atas 89 ayat, termasuk golongan  surat-surat Makkiyyah, diturunkan sesudah surat Asy Syuura. Dinamai Az Zukhruf (Perhiasan) diambil dari perkataan Az Zukhruf yang terdapat pada ayat 35 surat ini.  Orang-orang musyrik mengukur tinggi rendahnya derajat seseorang tergantung kepada perhiasan dan harta benda yang ia punyai, karena Muhammad s.a.w. adalah seorang anak yatim lagi miskin, ia tidak pantas diangkat Allah sebagai seorang rasul dan nabi.  Pangkat rasul dan nabi harus diberikan kepada orang yang kaya.  Ayat ini menegaskan bahwa harta tidak dapat dijadikan dasar untuk mengukur tinggi rendahnya derajat seseorang, karena harta itu merupakan hiasan kehidupan duniawi, bukan berarti kesenangan akhirat.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/043.mp3"
  }
  },
  {
  "number": 44,
  "ayahCount": 59,
  "sequence": 64,
  "asma": {
  "ar": {
  "short": "الدخان",
  "long": "سورة الدخان"
  },
  "en": {
  "short": "Ad-Dukhaan",
  "long": "Sura Ad-Dukhaan"
  },
  "id": {
  "short": "Ad-Dukhan",
  "long": "Surah Ad-Dukhan"
  },
  "translation": {
  "en": "The Smoke",
  "id": "Kabut"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ad Dukhaan terdiri atas 59 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah Az Zukhruf. Dinamai Ad Dukhaan (kabut), diambil dari perkataan Dukhaan yang terdapat pada ayat 10 surat ini.Menurut riwayat Bukhari secara ringkas dapat diterangkan sebagai berikut: Orang-orang kafir Mekah dalam menghalang-halangi agama Islam dan menyakiti serta mendurhakai Nabi Muhammad s.a.w. sudah melewati batas, karena itu Nabi mendoa kepada Allah agar diturunkan azab sebagaimana yang telah diturunkan kepada orang-orang yang durhaka kepada Nabi Yusuf yaitu musim kemarau yang panjang.  Do'a Nabi itu dikabulkan Allah sampai orang-orang kafir memakan tulang dan bangkai, karena kelaparan.  Mereka selalu menengadah ke langit mengharap pertolongan Allah.  Tetapi tidak satupun yang mereka lihat kecuali kabut yang menutupi pandangan mereka.Akhirnya mereka datang kepada Nabi agar Nabi memohon kepada Allah supaya hujan diturunkan.  Setelah Allah mengabulkan doa Nabi, dan hujan di turunkan, mereka kembali kafir seperti semula; karena itu Allah menyatakan bahwa nanti mereka akan diazab dengan azab yang pedih.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/044.mp3"
  }
  },
  {
  "number": 45,
  "ayahCount": 37,
  "sequence": 65,
  "asma": {
  "ar": {
  "short": "الجاثية",
  "long": "سورة الجاثية"
  },
  "en": {
  "short": "Al-Jaathiya",
  "long": "Sura Al-Jaathiya"
  },
  "id": {
  "short": "Al-Jasiyah",
  "long": "Surah Al-Jasiyah"
  },
  "translation": {
  "en": "Crouching",
  "id": "Berlutut"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Jaatsiyah terdiri atas 37 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Ad Dukhaan. Dinamai dengan Al Jaatsiyah (yang berlutut) diambil dari perkataan Jaatsiyah yang terdapat pada ayat 28 surat ini. Ayat tersebut menerangkan tentang keadaan manusia pada hari kiamat, yaitu semua manusia dikumpulkan ke hadapan mahkamah Allah Yang Maha Tinggi yang memberikan keputusan terhadap perbuatan yang telah mereka lakukan di dunia. Pada hari itu semua manusia berlutut di hadapan Allah. Dinamai juga dengan Asy Syari'ah diambil dari perkataan Syari'ah (Syari'at) yang terdapat pada ayat 18 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/045.mp3"
  }
  },
  {
  "number": 46,
  "ayahCount": 35,
  "sequence": 66,
  "asma": {
  "ar": {
  "short": "الأحقاف",
  "long": "سورة الأحقاف"
  },
  "en": {
  "short": "Al-Ahqaf",
  "long": "Sura Al-Ahqaf"
  },
  "id": {
  "short": "Al-Ahqaf",
  "long": "Surah Al-Ahqaf"
  },
  "translation": {
  "en": "The Dunes",
  "id": "Bukit Pasir"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Ahqaaf terdiri dari 35 ayat termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Jaatsiyah. Dinamai Al Ahqaaf  (bukit-bukit pasir) dari perkataan Al Ahqaaf yang terdapat pada ayat 21 surat ini.Dalam ayat tersebut dan ayat-ayat sesudahnya diterangkan bahwa Nabi Hud a.s. telah menyampaikan risalahnya kepada kaumnya di Al Ahqaaf yang sekarang dikenal dengan Ar Rab'ul Khaali, tetapi kaumnya tetap ingkar sekalipun mereka telah diberi peringatan pula oleh rasul-rasul yang sebelumnya.  Akhirnya Allah menghancurkan mereka dengan tiupan angin kencang.  Hal ini adalah sebagai isyarat dari Allah kepada kaum musyrikin Quraisy bahwa mereka akan dihancurkan bila mereka tidak mengindahkan seruan Rasul.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/046.mp3"
  }
  },
  {
  "number": 47,
  "ayahCount": 38,
  "sequence": 95,
  "asma": {
  "ar": {
  "short": "محمد",
  "long": "سورة محمد"
  },
  "en": {
  "short": "Muhammad",
  "long": "Sura Muhammad"
  },
  "id": {
  "short": "Muhammad",
  "long": "Surah Muhammad"
  },
  "translation": {
  "en": "Muhammad",
  "id": "Muhammad"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Muhammad terdiri atas 38 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Hadiid. Nama Muhammad sebagai nama surat ini diambil dari perkataan Muhammad yang terdapat pada ayat 2 surat ini. Pada ayat 1, 2, dan 3 surat ini, Allah membandingkan antara hasil yang diperoleh oleh orang-orang yang tidak percaya kepada apa yang diturunkan kepada Nabi Muhammad s.a.w dan hasil yang diperoleh oleh orang-orang yang tidak percaya kepadanya. Orang-orang yang percaya kepada apa yang dibawa oleh Muhammad s.a.w merekalah orang-orang yang beriman dan mengikuti yang hak, diterima Allah semua amalnya, diampuni segala kesalahannya. Adapun orang-orang yang tidak percaya kepada Muhammad s.a.w adalah orang-orang yang mengikuti kebatilan, amalnya tidak diterima, dosa mereka tidak diampuni, kepada mereka dijanjikan azab di dunia dan di akhirat.Dinamai juga dengan Al Qital (peperangan), karena sebahagian besar surat ini mengutarakan tentang peperangan dan pokok-pokok hukumnya, serta bagaimana seharusnya sikap orang-orang mukmin terhadap orang-orang kafir.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/047.mp3"
  }
  },
  {
  "number": 48,
  "ayahCount": 29,
  "sequence": 111,
  "asma": {
  "ar": {
  "short": "الفتح",
  "long": "سورة الفتح"
  },
  "en": {
  "short": "Al-Fath",
  "long": "Sura Al-Fath"
  },
  "id": {
  "short": "Al-Fath",
  "long": "Surah Al-Fath"
  },
  "translation": {
  "en": "The Victory",
  "id": "Kemenangan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Fath terdiri atas 29 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Jum'ah. Dinamakan Al Fath (kemenangan) diambil dari perkataan Fat-han yang terdapat pada ayat pertama surat ini. Sebagian besar dari ayat-ayat surat ini menerangkan hal-hal yang berhubungan dengan kemenangan yang dicapai Nabi Muhammad s.a.w. dalam peperangan-peperangannya. Nabi Muhammad s.a.w. sangat gembira dengan turunnya ayat pertama surat ini. Kegembiraan ini dinyatakan dalam sabda beliau yang diriwayatkan Bukhari; Sesungguhnya telah diturunkan kepadaku satu surat, yang surat itu benar-benar lebih aku cintai dari seluruh apa yang disinari matahari. Kegembiraan Nabi Muhammad s.a.w. itu ialah karena ayat-ayatnya menerangkan tentang kemenangan yang akan diperoleh Muhammad s.a.w. dalam perjuangannya dan tentang kesempurnaan nikmat Allah kepadanya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/048.mp3"
  }
  },
  {
  "number": 49,
  "ayahCount": 18,
  "sequence": 106,
  "asma": {
  "ar": {
  "short": "الحجرات",
  "long": "سورة الحجرات"
  },
  "en": {
  "short": "Al-Hujuraat",
  "long": "Sura Al-Hujuraat"
  },
  "id": {
  "short": "Al-Hujurat",
  "long": "Surah Al-Hujurat"
  },
  "translation": {
  "en": "The Inner Apartments",
  "id": "Kamar-Kamar"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Hujuraat terdiri atas 18 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Mujaadalah. Dinamai Al Hujuraat diambil dari perkataan Al Hujuraat yang terdapat pada ayat 4 surat ini. Ayat tersebut mencela para sahabat yang memanggil Nabi Muhammad SAW yang sedang berada di dalam kamar rumahnya bersama isterinya. Memanggil Nabi Muhammad SAW dengan cara dan dalam keadaan yang demikian menunjukkan sifat kurang hormat kepada beliau dan mengganggu ketenteraman beliau.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/049.mp3"
  }
  },
  {
  "number": 50,
  "ayahCount": 45,
  "sequence": 34,
  "asma": {
  "ar": {
  "short": "ق",
  "long": "سورة ق"
  },
  "en": {
  "short": "Qaaf",
  "long": "Sura Qaaf"
  },
  "id": {
  "short": "Qaf",
  "long": "Surah Qaf"
  },
  "translation": {
  "en": "The letter Qaaf",
  "id": "Qaf"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Qaaf terdiri atas 45 ayat, termasuk golongan surat-surat Makkiyah diturunkan sesudah surat Al Murssalaat. Dinamai Qaaf karena surat ini dimulai dengan huruf Qaaf. Menurut hadits yang diriwayatkan Imam Muslim, bahwa Rasulullah SAW senang membaca surat ini pada rakaat pertama sembahyang subuh dan pada shalat hari raya. Sedang menurut riwayat Abu Daud, Al Baihaqy dan Ibnu Majah bahwa Rasulullah SAW membaca surat ini pada tiap-tiap membaca Khutbah pada hari Jum'at. Kedua riwayat ini menunjukkan bahwa surat QAAF sering dibaca Nabi Muhammad SAW di tempat-tempat umum, untuk memperingatkan manusia tentang kejadian mereka dan nikmat-nikmat yang diberikan kepadanya, begitu pula tentang hari berbangkit, hari berhisab, syurga, neraka, pahala, dosa, dsb. Surat ini dinamai juga Al Baasiqaat, diambil dari perkataan Al- Baasiqaat yang terdapat pada ayat 10 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/050.mp3"
  }
  },
  {
  "number": 51,
  "ayahCount": 60,
  "sequence": 67,
  "asma": {
  "ar": {
  "short": "الذاريات",
  "long": "سورة الذاريات"
  },
  "en": {
  "short": "Adh-Dhaariyat",
  "long": "Sura Adh-Dhaariyat"
  },
  "id": {
  "short": "Az-Zariyat",
  "long": "Surah Az-Zariyat"
  },
  "translation": {
  "en": "The Winnowing Winds",
  "id": "Angin yang Menerbangkan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Adz Dzaariyaat terdiri atas 60 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Ahqaaf. Dinamai Adz Dzaariyaat (angin yang menerbangkan), diambil dari perkataan Adz Dzaariyaat yang terdapat pada ayat pertama surat ini. Allah bersumpah dengan angin, mega, bahtera, dan malaikat yang menjadi sumber kesejahteraan dan pembawa kemakmuran. Hal ini meng- isyaratkan inayat Allah kepada hamba-hamba-Nya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/051.mp3"
  }
  },
  {
  "number": 52,
  "ayahCount": 49,
  "sequence": 76,
  "asma": {
  "ar": {
  "short": "الطور",
  "long": "سورة الطور"
  },
  "en": {
  "short": "At-Tur",
  "long": "Sura At-Tur"
  },
  "id": {
  "short": "At-Tur",
  "long": "Surah At-Tur"
  },
  "translation": {
  "en": "The Mount",
  "id": "Bukit Tursina"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ath Thuur terdiri atas 49 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat As Sajdah. Dinamai Ath Thuur (Bukit) diambil dari perkataan Ath Thuur yang terdapat pada ayat pertama surat ini. Yang dimaksud dengan bukit di sini ialah bukit Thursina yang terletak di semenanjung Sinai, tempat Nabi Musa menerima wahyu dari Tuhannya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/052.mp3"
  }
  },
  {
  "number": 53,
  "ayahCount": 62,
  "sequence": 23,
  "asma": {
  "ar": {
  "short": "النجم",
  "long": "سورة النجم"
  },
  "en": {
  "short": "An-Najm",
  "long": "Sura An-Najm"
  },
  "id": {
  "short": "An-Najm",
  "long": "Surah An-Najm"
  },
  "translation": {
  "en": "The Star",
  "id": "Bintang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat An Najm terdiri atas 62 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Ikhlash. Nama An Najm (bintang), diambil dari perkataan  An Najm yang terdapat pada ayat pertama surat ini. Allah bersumpah dengan An Najm (bintang) adalah karena bintang-bintang yang timbul dan tenggelam, amat besar manfaatnya bagi manusia, sebagai pedoman bagi manusia dalam melakukan pelayaran di lautan, dalam perjalanan di padang pasir, untuk menentukan peredaran musim dan sebagainya.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/053.mp3"
  }
  },
  {
  "number": 54,
  "ayahCount": 55,
  "sequence": 37,
  "asma": {
  "ar": {
  "short": "القمر",
  "long": "سورة القمر"
  },
  "en": {
  "short": "Al-Qamar",
  "long": "Sura Al-Qamar"
  },
  "id": {
  "short": "Al-Qamar",
  "long": "Surah Al-Qamar"
  },
  "translation": {
  "en": "The Moon",
  "id": "Bulan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Qamar terdiri atas 55 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesedah surat Ath Thaariq. Nama Al Qamar (bulan) diambil dari perkataan Al Qamar yang terdapat pada ayat pertama surat ini. Pada ayat ini diterangkan tentang terbelahnya bulan sebagai mukjizat Nabi Muhammad s.a.w.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/054.mp3"
  }
  },
  {
  "number": 55,
  "ayahCount": 78,
  "sequence": 97,
  "asma": {
  "ar": {
  "short": "الرحمن",
  "long": "سورة الرحمن"
  },
  "en": {
  "short": "Ar-Rahmaan",
  "long": "Sura Ar-Rahmaan"
  },
  "id": {
  "short": "Ar-Rahman",
  "long": "Surah Ar-Rahman"
  },
  "translation": {
  "en": "The Beneficent",
  "id": "Maha Pengasih"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Ar Rahmaan terdiri atas 78 ayat, termasuk golongan surat- surat Madaniyyah, diturunkan sesudah surat Ar Ra'du. Dinamai Ar Rahmaan (Yang Maha Pemurah), diambil dari perkataan Ar Rahmaan yang terdapat pada ayat pertama surat ini. Ar Rahmaan adalah salah satu dari nama-nama Allah. Sebagian besar dari surat ini menerangkan kepemurahan Allah s.w.t. kepada hamba-hamba-Nya, yaitu dengan memberikan nikmat-nikmat yang tidak terhingga baik di dunia maupun di akhirat nanti.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/055.mp3"
  }
  },
  {
  "number": 56,
  "ayahCount": 96,
  "sequence": 46,
  "asma": {
  "ar": {
  "short": "الواقعة",
  "long": "سورة الواقعة"
  },
  "en": {
  "short": "Al-Waaqia",
  "long": "Sura Al-Waaqia"
  },
  "id": {
  "short": "Al-Waqi'ah",
  "long": "Surah Al-Waqi'ah"
  },
  "translation": {
  "en": "The Inevitable",
  "id": "Hari Kiamat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Waaqi'ah terdiri atas 96 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Thaa Haa. \tDinamai dengan Al Waaqi'ah (Hari Kiamat), diambil dari perkataan Al Waaqi'ah yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/056.mp3"
  }
  },
  {
  "number": 57,
  "ayahCount": 29,
  "sequence": 94,
  "asma": {
  "ar": {
  "short": "الحديد",
  "long": "سورة الحديد"
  },
  "en": {
  "short": "Al-Hadid",
  "long": "Sura Al-Hadid"
  },
  "id": {
  "short": "Al-Hadid",
  "long": "Surah Al-Hadid"
  },
  "translation": {
  "en": "The Iron",
  "id": "Besi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Hadiid terdiri atas 29 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Az Zalzalah. Dinamai Al Hadiid (Besi), diambil dari perkataan Al Hadiid yang terdapat pada ayat 25 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/057.mp3"
  }
  },
  {
  "number": 58,
  "ayahCount": 22,
  "sequence": 105,
  "asma": {
  "ar": {
  "short": "المجادلة",
  "long": "سورة المجادلة"
  },
  "en": {
  "short": "Al-Mujaadila",
  "long": "Sura Al-Mujaadila"
  },
  "id": {
  "short": "Al-Mujadalah",
  "long": "Surah Al-Mujadalah"
  },
  "translation": {
  "en": "The Pleading Woman",
  "id": "Gugatan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Mujaadilah terdiri atas 22 ayat, termasuk golongan surat Madaniyyah, diturunkan sesudah surat Al Munaafiquun. Surat ini dinamai dengan Al Mujaadilah (wanita yang mengajukan gugatan) karena pada awal surat ini disebutkan bantahan seorang perempuan, menurut riwayat bernama Khaulah binti Tsa'labah terhadap sikap suaminya yang telah menzhiharnya. Hal ini diadukan kepada Rasulullah s.a.w. dan ia menuntut supaya beliau memberikan putusan yang adil dalam persoalan itu. Dinamai juga Al Mujaadalah yang berarti perbantahan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/058.mp3"
  }
  },
  {
  "number": 59,
  "ayahCount": 24,
  "sequence": 101,
  "asma": {
  "ar": {
  "short": "الحشر",
  "long": "سورة الحشر"
  },
  "en": {
  "short": "Al-Hashr",
  "long": "Sura Al-Hashr"
  },
  "id": {
  "short": "Al-Hasyr",
  "long": "Surah Al-Hasyr"
  },
  "translation": {
  "en": "The Exile",
  "id": "Pengusiran"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Hasyr terdiri atas 24 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Bayyinah. \tDinamai surat Al Hasyr (pengusiran) diambil dari perkataan Al-Hasyr yang terdapat pada ayat 2 surat ini. Di dalam surat ini disebutkan  kisah pengusiran suatu suku Yahudi yang bernama Bani Nadhir yang berdiam  di sekitar kota Madinah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/059.mp3"
  }
  },
  {
  "number": 60,
  "ayahCount": 13,
  "sequence": 91,
  "asma": {
  "ar": {
  "short": "الممتحنة",
  "long": "سورة الممتحنة"
  },
  "en": {
  "short": "Al-Mumtahana",
  "long": "Sura Al-Mumtahana"
  },
  "id": {
  "short": "Al-Mumtahanah",
  "long": "Surah Al-Mumtahanah"
  },
  "translation": {
  "en": "She that is to be examined",
  "id": "Wanita Yang Diuji"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Mumtahanah terdiri atas 13 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Ahzab. Dinamai Al Mumtahanah (wanita yang diuji), diambil dari kata \"Famtahinuuhunna\" yang berarti maka ujilah mereka, yang terdapat pada ayat 10 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/060.mp3"
  }
  },
  {
  "number": 61,
  "ayahCount": 14,
  "sequence": 109,
  "asma": {
  "ar": {
  "short": "الصف",
  "long": "سورة الصف"
  },
  "en": {
  "short": "As-Saff",
  "long": "Sura As-Saff"
  },
  "id": {
  "short": "As-Saff",
  "long": "Surah As-Saff"
  },
  "translation": {
  "en": "The Ranks",
  "id": "Barisan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Ash Shaff terdiri atas 14 ayat termasuk golongan surat-surat Madaniyyah. Dinamai dengan Ash Shaff, karena pada ayat 4 surat ini terdapat kata Shaffan yang berarti satu barisan. Ayat ini menerangkan apa yang diridhai Allah sesudah menerangkan apa yang dimurkai-Nya. Pada ayat 3 diterangkan bahwa Allah murka kepada orang yang hanya pandai berkata saja tetapi tidak melaksanakan apa yang diucapkannya. Dan pada ayat 4 diterangkan bahwa Allah menyukai orang yang mempraktekkan apa yang diucapkannya yaitu orang-orang yang berperang pada jalan Allah dalam satu barisan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/061.mp3"
  }
  },
  {
  "number": 62,
  "ayahCount": 11,
  "sequence": 110,
  "asma": {
  "ar": {
  "short": "الجمعة",
  "long": "سورة الجمعة"
  },
  "en": {
  "short": "Al-Jumu'a",
  "long": "Sura Al-Jumu'a"
  },
  "id": {
  "short": "Al-Jumu'ah",
  "long": "Surah Al-Jumu'ah"
  },
  "translation": {
  "en": "Friday",
  "id": "Jumat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Jumu'ah ini terdiri atas 11 ayat, termasuk golongan-golongan surat-surat Madaniyyah dan diturunkan sesudah surat Ash Shaf. Nama surat Al Jumu'ah diambil dari kata Al Jumu'ah yang terdapat pada ayat 9 surat ini yang artinya: hari Jum'at.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/062.mp3"
  }
  },
  {
  "number": 63,
  "ayahCount": 11,
  "sequence": 104,
  "asma": {
  "ar": {
  "short": "المنافقون",
  "long": "سورة المنافقون"
  },
  "en": {
  "short": "Al-Munaafiqoon",
  "long": "Sura Al-Munaafiqoon"
  },
  "id": {
  "short": "Al-Munafiqun",
  "long": "Surah Al-Munafiqun"
  },
  "translation": {
  "en": "The Hypocrites",
  "id": "Orang-Orang Munafik"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 11 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Hajj. Surat ini dinamai Al-Munaafiquun  yang artinya orang-orang munafik, karena surat ini mengungkapkan  sifat-sifat orang-orang munafik.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/063.mp3"
  }
  },
  {
  "number": 64,
  "ayahCount": 18,
  "sequence": 108,
  "asma": {
  "ar": {
  "short": "التغابن",
  "long": "سورة التغابن"
  },
  "en": {
  "short": "At-Taghaabun",
  "long": "Sura At-Taghaabun"
  },
  "id": {
  "short": "At-Tagabun",
  "long": "Surah At-Tagabun"
  },
  "translation": {
  "en": "Mutual Disillusion",
  "id": "Pengungkapan Kesalahan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 18 ayat, termasuk golongan surat-surat Madaniyyah dan diturunkan sesudah surat At Tahrim. Nama At Taghaabun diambil dari kata At Taghaabun yang terdapat pada ayat ke 9 yang artinya hari dinampakkan kesalahan-kesalahan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/064.mp3"
  }
  },
  {
  "number": 65,
  "ayahCount": 12,
  "sequence": 99,
  "asma": {
  "ar": {
  "short": "الطلاق",
  "long": "سورة الطلاق"
  },
  "en": {
  "short": "At-Talaaq",
  "long": "Sura At-Talaaq"
  },
  "id": {
  "short": "At-Talaq",
  "long": "Surah At-Talaq"
  },
  "translation": {
  "en": "Divorce",
  "id": "Talak"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 12 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Insaan. Dinamai surat Ath Thalaaq karena kebanyakan ayat-ayatnya mengenai masalah talak dan yang berhubungan dengan masalah itu.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/065.mp3"
  }
  },
  {
  "number": 66,
  "ayahCount": 12,
  "sequence": 107,
  "asma": {
  "ar": {
  "short": "التحريم",
  "long": "سورة التحريم"
  },
  "en": {
  "short": "At-Tahrim",
  "long": "Sura At-Tahrim"
  },
  "id": {
  "short": "At-Tahrim",
  "long": "Surah At-Tahrim"
  },
  "translation": {
  "en": "The Prohibition",
  "id": "Pengharaman"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 12 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Al Hujuraat. Dinamai surat At Tahrim karena pada awal surat ini terdapat kata tuharrim yang kata asalnya adalah Attahrim yang berarti mengharamkan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/066.mp3"
  }
  },
  {
  "number": 67,
  "ayahCount": 30,
  "sequence": 77,
  "asma": {
  "ar": {
  "short": "الملك",
  "long": "سورة الملك"
  },
  "en": {
  "short": "Al-Mulk",
  "long": "Sura Al-Mulk"
  },
  "id": {
  "short": "Al-Mulk",
  "long": "Surah Al-Mulk"
  },
  "translation": {
  "en": "The Sovereignty",
  "id": "Kerajaan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 30 ayat, termasuk golongan surat-surat  Makkiyah, diturunkan sesudah Ath Thuur. Nama Al Mulk diambil dari kata Al Mulk yang terdapat pada ayat pertama surat ini yang artinya kerajaan atau kekuasaan. Dinamai pula surat ini dengan At Tabaarak (Maha Suci).",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/067.mp3"
  }
  },
  {
  "number": 68,
  "ayahCount": 52,
  "sequence": 2,
  "asma": {
  "ar": {
  "short": "القلم",
  "long": "سورة القلم"
  },
  "en": {
  "short": "Al-Qalam",
  "long": "Sura Al-Qalam"
  },
  "id": {
  "short": "Al-Qalam",
  "long": "Surah Al-Qalam"
  },
  "translation": {
  "en": "The Pen",
  "id": "Pena"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 52 ayat,termasuk golongan surat-surat Makkiyah,diturunkan sesudah surat Al Alaq. Nama Al Qalam diambil dari kata Al Qalam yang terdapat pada ayat pertama surat iniyang artinya pena. Surat ini dinamai pula dengan surat Nun (huruf nun).",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/068.mp3"
  }
  },
  {
  "number": 69,
  "ayahCount": 52,
  "sequence": 78,
  "asma": {
  "ar": {
  "short": "الحاقة",
  "long": "سورة الحاقة"
  },
  "en": {
  "short": "Al-Haaqqa",
  "long": "Sura Al-Haaqqa"
  },
  "id": {
  "short": "Al-Haqqah",
  "long": "Surah Al-Haqqah"
  },
  "translation": {
  "en": "The Reality",
  "id": "Hari Kiamat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 52 ayat,termasuk golongan surat-surat Makkiyah,diturunkan sesudah surat Al Mulk.  Nama Al Haaqqah diambil dari kata Al Haaqqah yang terdapat pada ayat pertama surat ini yang artinya hari kiamat",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/069.mp3"
  }
  },
  {
  "number": 70,
  "ayahCount": 44,
  "sequence": 79,
  "asma": {
  "ar": {
  "short": "المعارج",
  "long": "سورة المعارج"
  },
  "en": {
  "short": "Al-Ma'aarij",
  "long": "Sura Al-Ma'aarij"
  },
  "id": {
  "short": "Al-Ma'arij",
  "long": "Surah Al-Ma'arij"
  },
  "translation": {
  "en": "The Ascending Stairways",
  "id": "Tempat Naik"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 44 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Haaqqah.Perkataan Al Ma'arij yang menjadi nama bagi surat ini adalah kata jamak dari Mi'raj, diambil dari perkataan Al Ma'arij yang terdapat pada ayat 3, yang artinya menurut bahasa tempat naik. Sedang para ahli  tafsir memberi arti bermacam-macam, di antaranya langit, nikmat karunia dan derajat atau tingkatan yang diberikan Allah s.w.t kepada ahli surga.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/070.mp3"
  }
  },
  {
  "number": 71,
  "ayahCount": 28,
  "sequence": 71,
  "asma": {
  "ar": {
  "short": "نوح",
  "long": "سورة نوح"
  },
  "en": {
  "short": "Nooh",
  "long": "Sura Nooh"
  },
  "id": {
  "short": "Nuh",
  "long": "Surah Nuh"
  },
  "translation": {
  "en": "Noah",
  "id": "Nuh"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 28 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat An Nahl. Dinamakan dengan surat Nuh karena surat ini seluruhnya menjelaskan da'wah dan doa Nabi Nuh a.s.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/071.mp3"
  }
  },
  {
  "number": 72,
  "ayahCount": 28,
  "sequence": 40,
  "asma": {
  "ar": {
  "short": "الجن",
  "long": "سورة الجن"
  },
  "en": {
  "short": "Al-Jinn",
  "long": "Sura Al-Jinn"
  },
  "id": {
  "short": "Al-Jinn",
  "long": "Surah Al-Jinn"
  },
  "translation": {
  "en": "The Jinn",
  "id": "Jin"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Jin terdiri atas 28 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al A'raaf. Dinamai Al Jin diambil dari perkataan Al Jin yang terdapat  pada ayat pertama surat ini. Pada ayat tersebut dan ayat-ayat berikutnya  diterangkan bahwa Jin sebagai makhluk halus telah mendengar pembacaan  Al Quran dan mereka mengikuti ajaran Al Quran tersebut.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/072.mp3"
  }
  },
  {
  "number": 73,
  "ayahCount": 20,
  "sequence": 3,
  "asma": {
  "ar": {
  "short": "المزمل",
  "long": "سورة المزمل"
  },
  "en": {
  "short": "Al-Muzzammil",
  "long": "Sura Al-Muzzammil"
  },
  "id": {
  "short": "Al-Muzzammil",
  "long": "Surah Al-Muzzammil"
  },
  "translation": {
  "en": "The Enshrouded One",
  "id": "Orang Yang Berselimut"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Muzzammil terdiri atas 20 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Qalam.Dinamai Al Muzzammil (orang yang berselimut) diambil dari perkataan Al Muzzammil yang terdapat pada ayat pertama surat ini. Yang dimaksud dengan orang yang berkemul ialah Nabi Muhammad s.a.w.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/073.mp3"
  }
  },
  {
  "number": 74,
  "ayahCount": 56,
  "sequence": 4,
  "asma": {
  "ar": {
  "short": "المدثر",
  "long": "سورة المدثر"
  },
  "en": {
  "short": "Al-Muddaththir",
  "long": "Sura Al-Muddaththir"
  },
  "id": {
  "short": "Al-Muddassir",
  "long": "Surah Al-Muddassir"
  },
  "translation": {
  "en": "The Cloaked One",
  "id": "Orang Yang Berkemul"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Muddatstsir terdiri atas 56 ayat, termasuk golongan  surat-surat Makkiyah, diturunkan sesudah surat Al Muzzammil. \tDinamai Al Muddatstsir (orang yang berkemul) diambil dari perkataan Al Muddatstsir yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/074.mp3"
  }
  },
  {
  "number": 75,
  "ayahCount": 40,
  "sequence": 31,
  "asma": {
  "ar": {
  "short": "القيامة",
  "long": "سورة القيامة"
  },
  "en": {
  "short": "Al-Qiyaama",
  "long": "Sura Al-Qiyaama"
  },
  "id": {
  "short": "Al-Qiyamah",
  "long": "Surah Al-Qiyamah"
  },
  "translation": {
  "en": "The Resurrection",
  "id": "Hari Kiamat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Qiyaamah terdiri atas 40 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Qaari'ah. Dinamai Al Qiyaamah (hari kiamat) diambil dari perkataan Al Qiyaamah yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/075.mp3"
  }
  },
  {
  "number": 76,
  "ayahCount": 31,
  "sequence": 98,
  "asma": {
  "ar": {
  "short": "الانسان",
  "long": "سورة الانسان"
  },
  "en": {
  "short": "Al-Insaan",
  "long": "Sura Al-Insaan"
  },
  "id": {
  "short": "Al-Insan",
  "long": "Surah Al-Insan"
  },
  "translation": {
  "en": "Man",
  "id": "Manusia"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Insaan terdiri atas 31 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Ar Rahmaan. Dinamai al Insaan (manusia) diambil dari perkataan Al Insaan yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/076.mp3"
  }
  },
  {
  "number": 77,
  "ayahCount": 50,
  "sequence": 33,
  "asma": {
  "ar": {
  "short": "المرسلات",
  "long": "سورة المرسلات"
  },
  "en": {
  "short": "Al-Mursalaat",
  "long": "Sura Al-Mursalaat"
  },
  "id": {
  "short": "Al-Mursalat",
  "long": "Surah Al-Mursalat"
  },
  "translation": {
  "en": "The Emissaries",
  "id": "Malaikat Yang Diutus"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Mursalaat terdiri atas 50 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Humazah. Dinamai Al Mursalaat (Malaikat-Malaikat yang diutus), diambil dari perkataan Al Mursalaat yang terdapat pada ayat pertama surat ini. Dinamai juga Amma yatasaa aluun diambil dari perkataan Amma yatasaa aluun yang terdapat pada ayat 1 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/077.mp3"
  }
  },
  {
  "number": 78,
  "ayahCount": 40,
  "sequence": 80,
  "asma": {
  "ar": {
  "short": "النبإ",
  "long": "سورة النبأ"
  },
  "en": {
  "short": "An-Naba",
  "long": "Sura An-Naba"
  },
  "id": {
  "short": "An-Naba'",
  "long": "Surah An-Naba'"
  },
  "translation": {
  "en": "The Announcement",
  "id": "Berita Besar"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat An Naba´ terdiri atas 40 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Ma´aarij. Dinamai An Naba´ (berita besar) diambil dari perkataan An Naba´ yang terdapat pada ayat 2 surat ini. Dinamai juga Amma yatasaa aluun diambil dari perkataan Amma yatasaa aluun yang terdapat pada ayat 1 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/078.mp3"
  }
  },
  {
  "number": 79,
  "ayahCount": 46,
  "sequence": 81,
  "asma": {
  "ar": {
  "short": "النازعات",
  "long": "سورة النازعات"
  },
  "en": {
  "short": "An-Naazi'aat",
  "long": "Sura An-Naazi'aat"
  },
  "id": {
  "short": "An-Nazi'at",
  "long": "Surah An-Nazi'at"
  },
  "translation": {
  "en": "Those who drag forth",
  "id": "Malaikat Yang Mencabut"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat An Naazi´aat terdiri atas 46 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat An Naba´. Dinamai An Naazi´aat diambil dari perkataan An Naazi´aat yang terdapat pada ayat pertama surat ini. Dinamai pula as Saahirah yang diambil dari ayat 14, dinamai juga Ath Thaammah diambil dari ayat 34.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/079.mp3"
  }
  },
  {
  "number": 80,
  "ayahCount": 42,
  "sequence": 24,
  "asma": {
  "ar": {
  "short": "عبس",
  "long": "سورة عبس"
  },
  "en": {
  "short": "Abasa",
  "long": "Sura Abasa"
  },
  "id": {
  "short": "'Abasa",
  "long": "Surah 'Abasa"
  },
  "translation": {
  "en": "He frowned",
  "id": "Bermuka Masam"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat 'Abasa terdiri atas 42 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat An Najm. Dinamai 'Abasa  diambil dari perkataan 'Abasa yang terdapat pada ayat pertama surat ini. Menurut riwayat, pada suatu ketika Rasulullah s.a.w. menerima dan berbicara dengan pemuka-pemuka Quraisy yang beliau harapkan agar mereka masuk Islam. Dalam pada itu datanglah Ibnu Ummi Maktum, seorang sahabat yang buta yang mengharap agar Rasulullah s.a.w. membacakan kepadanya ayat- ayat Al Quran yang telah diturunkan Allah. tetapi Rasulullah s.a.w. bermuka masam dan memalingkan muka dari Ibnu Ummi Maktum yang buta itu, lalu Allah menurunkan surat ini sebagai teguran atas sikap Rasulullah terhadap ibnu Ummi Maktum itu.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/080.mp3"
  }
  },
  {
  "number": 81,
  "ayahCount": 29,
  "sequence": 7,
  "asma": {
  "ar": {
  "short": "التكوير",
  "long": "سورة التكوير"
  },
  "en": {
  "short": "At-Takwir",
  "long": "Sura At-Takwir"
  },
  "id": {
  "short": "At-Takwir",
  "long": "Surah At-Takwir"
  },
  "translation": {
  "en": "The Overthrowing",
  "id": "Penggulungan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat At Takwir terdiri atas 29 ayat dan termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Masadd. Kata At Takwir (terbelah) yang menjadi nama bagi surat ini adalah dari kata asal (mashdar) dari kata kerja kuwwirat (digulung) yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/081.mp3"
  }
  },
  {
  "number": 82,
  "ayahCount": 19,
  "sequence": 82,
  "asma": {
  "ar": {
  "short": "الإنفطار",
  "long": "سورة الإنفطار"
  },
  "en": {
  "short": "Al-Infitaar",
  "long": "Sura Al-Infitaar"
  },
  "id": {
  "short": "Al-Infitar",
  "long": "Surah Al-Infitar"
  },
  "translation": {
  "en": "The Cleaving",
  "id": "Terbelah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 19 ayat, termasuk golongan surat-surat Makkiyah dan diturunkan sesudah surat An Naazi'aat. Al Infithaar yang dijadikan  nama untuk surat ini adalah kata asal dari kata Infatharat (terbelah)  yang terdapat pada ayat pertama.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/082.mp3"
  }
  },
  {
  "number": 83,
  "ayahCount": 36,
  "sequence": 86,
  "asma": {
  "ar": {
  "short": "المطففين",
  "long": "سورة المطففين"
  },
  "en": {
  "short": "Al-Mutaffifin",
  "long": "Sura Al-Mutaffifin"
  },
  "id": {
  "short": "Al-Mutaffifin",
  "long": "Surah Al-Mutaffifin"
  },
  "translation": {
  "en": "Defrauding",
  "id": "Orang-Orang Curang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 36 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al 'Ankabuut dan merupakan  surat yang terakhir di Mekkah sebelum hijrah. Al Muthaffifiin  yang dijadikan nama bagi surat ini diambil dari kata  Al Muthaffifiin yang terdapat pada ayat pertama.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/083.mp3"
  }
  },
  {
  "number": 84,
  "ayahCount": 25,
  "sequence": 83,
  "asma": {
  "ar": {
  "short": "الإنشقاق",
  "long": "سورة الإنشقاق"
  },
  "en": {
  "short": "Al-Inshiqaaq",
  "long": "Sura Al-Inshiqaaq"
  },
  "id": {
  "short": "Al-Insyiqaq",
  "long": "Surah Al-Insyiqaq"
  },
  "translation": {
  "en": "The Splitting Open",
  "id": "Terbelah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Insyiqaaq, terdiri atas 25 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Infithaarr. Dinamai Al Insyiqaaq (terbelah), diambil dari perkataan Insyaqqat yang terdapat pada permulaan surat ini, yang pokok katanya ialah insyiqaaq.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/084.mp3"
  }
  },
  {
  "number": 85,
  "ayahCount": 22,
  "sequence": 27,
  "asma": {
  "ar": {
  "short": "البروج",
  "long": "سورة البروج"
  },
  "en": {
  "short": "Al-Burooj",
  "long": "Sura Al-Burooj"
  },
  "id": {
  "short": "Al-Buruj",
  "long": "Surah Al-Buruj"
  },
  "translation": {
  "en": "The Constellations",
  "id": "Gugusan Bintang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Buruuj terdiri atas 22 ayat, termasuk golongan surat-surat Makkiyyah diturunkan sesudah surat Asy-Syams.Dinamai Al Buruuj (gugusan bintang) diambil dari perkataan Al Buruuj yang terdapat pada ayat 1 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/085.mp3"
  }
  },
  {
  "number": 86,
  "ayahCount": 17,
  "sequence": 36,
  "asma": {
  "ar": {
  "short": "الطارق",
  "long": "سورة الطارق"
  },
  "en": {
  "short": "At-Taariq",
  "long": "Sura At-Taariq"
  },
  "id": {
  "short": "At-Tariq",
  "long": "Surah At-Tariq"
  },
  "translation": {
  "en": "The Morning Star",
  "id": "Yang Datang Di Malam Hari"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Ath Thaariq terdiri atas 17 ayat, termasuk golongan surat-surat Makkiyah,  diturunkan sesudah surat Al Balad.  Dinamai Ath Thaariq (yang datang di malam hari) diambil dari  perkataan Ath Thaariq yang terdapat pada ayat 1 surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/086.mp3"
  }
  },
  {
  "number": 87,
  "ayahCount": 19,
  "sequence": 8,
  "asma": {
  "ar": {
  "short": "الأعلى",
  "long": "سورة الأعلى"
  },
  "en": {
  "short": "Al-A'laa",
  "long": "Sura Al-A'laa"
  },
  "id": {
  "short": "Al-A'la",
  "long": "Surah Al-A'la"
  },
  "translation": {
  "en": "The Most High",
  "id": "Maha Tinggi"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 19 ayat, termasuk golongan surat-surat Makkiyyah, dan diturunkan sesudah surat At Takwiir. Nama Al A´laa diambil dari kata Al A´laa yang terdapat pada ayat pertama, berarti Yang Paling Tinggi. Muslim meriwayatkan dalam kitab Al Jumu'ah, dan diriwayatkan pula oleh Ashhaabus Sunan, dari Nu'man ibnu Basyir bahwa Rasulullah s.a.w. pada shalat dua hari Raya (Fitri dan Adha) dan shalat Jum'at membaca surat Al A´laa pada rakaat pertama, dan surat Al Ghaasyiyah pada rakaat kedua.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/087.mp3"
  }
  },
  {
  "number": 88,
  "ayahCount": 26,
  "sequence": 68,
  "asma": {
  "ar": {
  "short": "الغاشية",
  "long": "سورة الغاشية"
  },
  "en": {
  "short": "Al-Ghaashiya",
  "long": "Sura Al-Ghaashiya"
  },
  "id": {
  "short": "Al-Gasyiyah",
  "long": "Surah Al-Gasyiyah"
  },
  "translation": {
  "en": "The Overwhelming",
  "id": "Hari Kiamat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 26 ayat, termasuk surat-surat Makkiyah, diturunkan sesudah surat Adz Dzaariat. Nama Ghaasyiyah diambil dari kata Al Ghaasyiyah yang terdapat pada ayat pertama surat ini yang  artinya peristiwa yang dahsyat, tapi yang dimaksud adalah hari kiamat. Surat ini adalah surat yang kerap kali dibaca Nabi pada rakaat kedua  pada shalat hari-hari Raya dan shalat Jum'at",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/088.mp3"
  }
  },
  {
  "number": 89,
  "ayahCount": 30,
  "sequence": 10,
  "asma": {
  "ar": {
  "short": "الفجر",
  "long": "سورة الفجر"
  },
  "en": {
  "short": "Al-Fajr",
  "long": "Sura Al-Fajr"
  },
  "id": {
  "short": "Al-Fajr",
  "long": "Surah Al-Fajr"
  },
  "translation": {
  "en": "The Dawn",
  "id": "Fajar"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 30 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Lail. Nama Al Fajr diambil dari kata Al Fajr yang terdapat pada ayat pertama surat ini yang artinya fajar.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/089.mp3"
  }
  },
  {
  "number": 90,
  "ayahCount": 20,
  "sequence": 35,
  "asma": {
  "ar": {
  "short": "البلد",
  "long": "سورة البلد"
  },
  "en": {
  "short": "Al-Balad",
  "long": "Sura Al-Balad"
  },
  "id": {
  "short": "Al-Balad",
  "long": "Surah Al-Balad"
  },
  "translation": {
  "en": "The City",
  "id": "Negeri"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Balad terdiri atas 20 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Qaaf. Dinamai Al Balad, diambil dari perkataan Al Balad yang terdapat  pada ayat pertama surat ini. Yang dimaksud dengan kota di sini ialah kota Mekah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/090.mp3"
  }
  },
  {
  "number": 91,
  "ayahCount": 15,
  "sequence": 26,
  "asma": {
  "ar": {
  "short": "الشمس",
  "long": "سورة الشمس"
  },
  "en": {
  "short": "Ash-Shams",
  "long": "Sura Ash-Shams"
  },
  "id": {
  "short": "Asy-Syams",
  "long": "Surah Asy-Syams"
  },
  "translation": {
  "en": "The Sun",
  "id": "Matahari"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Asy Syams terdiri atas 15 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Qadar.  Dinamai Asy Syams (matahari) diambil dari perkataan Asy Syams yang terdapat pada ayat permulaan surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/091.mp3"
  }
  },
  {
  "number": 92,
  "ayahCount": 21,
  "sequence": 9,
  "asma": {
  "ar": {
  "short": "الليل",
  "long": "سورة الليل"
  },
  "en": {
  "short": "Al-Lail",
  "long": "Sura Al-Lail"
  },
  "id": {
  "short": "Al-Lail",
  "long": "Surah Al-Lail"
  },
  "translation": {
  "en": "The Night",
  "id": "Malam"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 21 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al A'laa. Surat ini dinamai Al Lail (malam), diambil dari perkataan Al Lail yang terdapat pada ayat pertama surat ini",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/092.mp3"
  }
  },
  {
  "number": 93,
  "ayahCount": 11,
  "sequence": 11,
  "asma": {
  "ar": {
  "short": "الضحى",
  "long": "سورة الضحى"
  },
  "en": {
  "short": "Ad-Dhuhaa",
  "long": "Sura Ad-Dhuhaa"
  },
  "id": {
  "short": "Ad-Duha",
  "long": "Surah Ad-Duha"
  },
  "translation": {
  "en": "The Morning Hours",
  "id": "Duha"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 11 ayat, termasuk golongan surat Makiyyah dan diturunkan sesudah surat Al Fajr. Nama Adh Dhuhaa diambil dari kata yang terdapat pada ayat pertama, artinya : waktu matahari sepenggalahan naik.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/093.mp3"
  }
  },
  {
  "number": 94,
  "ayahCount": 8,
  "sequence": 12,
  "asma": {
  "ar": {
  "short": "الشرح",
  "long": "سورة الشرح"
  },
  "en": {
  "short": "Ash-Sharh",
  "long": "Sura Ash-Sharh"
  },
  "id": {
  "short": "Asy-Syarh",
  "long": "Surah Asy-Syarh"
  },
  "translation": {
  "en": "The Consolation",
  "id": "Lapang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 8 ayat, termasuk golongan surat-surat Makkiyah dan diturunkan sesudah surat Adh Dhuhaa. Nama Alam Nasyrah diambil dari kata Alam Nasyrah yang terdapat pada ayat pertama, yang berarti: bukankah Kami telah melapangkan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/094.mp3"
  }
  },
  {
  "number": 95,
  "ayahCount": 8,
  "sequence": 28,
  "asma": {
  "ar": {
  "short": "التين",
  "long": "سورة التين"
  },
  "en": {
  "short": "At-Tin",
  "long": "Sura At-Tin"
  },
  "id": {
  "short": "At-Tin",
  "long": "Surah At-Tin"
  },
  "translation": {
  "en": "The Fig",
  "id": "Buah Tin"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 8 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Buruuj. Nama At Tiin diambil dari kata At Tiin yang terdapat pada ayat pertama surat ini yang artinya buah Tin.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/095.mp3"
  }
  },
  {
  "number": 96,
  "ayahCount": 19,
  "sequence": 1,
  "asma": {
  "ar": {
  "short": "العلق",
  "long": "سورة العلق"
  },
  "en": {
  "short": "Al-Alaq",
  "long": "Sura Al-Alaq"
  },
  "id": {
  "short": "Al-'Alaq",
  "long": "Surah Al-'Alaq"
  },
  "translation": {
  "en": "The Clot",
  "id": "Segumpal Darah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al 'Alaq terdiri atas 19 ayat, termasuk golongan surat-surat Makkiyah. Ayat 1 sampai dengan 5 dari surat ini adalah ayat-ayat Al Quran yang pertama sekali diturunkan, yaitu di waktu Nabi Muhammad s.a.w. berkhalwat di gua Hira'. Surat ini dinamai Al 'Alaq (segumpal darah), diambil dari perkataan Alaq yang terdapat pada ayat 2 surat ini. Surat ini dinamai juga dengan Iqra atau Al Qalam.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/096.mp3"
  }
  },
  {
  "number": 97,
  "ayahCount": 5,
  "sequence": 25,
  "asma": {
  "ar": {
  "short": "القدر",
  "long": "سورة القدر"
  },
  "en": {
  "short": "Al-Qadr",
  "long": "Sura Al-Qadr"
  },
  "id": {
  "short": "Al-Qadr",
  "long": "Surah Al-Qadr"
  },
  "translation": {
  "en": "The Power, Fate",
  "id": "Kemuliaan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Qadr terdiri atas 5 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat 'Abasa. Surat ini dinamai Al Qadr (kemuliaan), diambil dari perkataan Al Qadr yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/097.mp3"
  }
  },
  {
  "number": 98,
  "ayahCount": 8,
  "sequence": 100,
  "asma": {
  "ar": {
  "short": "البينة",
  "long": "سورة البينة"
  },
  "en": {
  "short": "Al-Bayyina",
  "long": "Sura Al-Bayyina"
  },
  "id": {
  "short": "Al-Bayyinah",
  "long": "Surah Al-Bayyinah"
  },
  "translation": {
  "en": "The Evidence",
  "id": "Bukti Nyata"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat Al Bayyinah terdiri atas 8 ayat, termasuk golongan surat-surat Madaniyyah, diturunkan sesudah surat Ath Thalaq. Dinamai Al Bayyinah (bukti yang nyata) diambil dari perkataan Al Bayyinah yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/098.mp3"
  }
  },
  {
  "number": 99,
  "ayahCount": 8,
  "sequence": 93,
  "asma": {
  "ar": {
  "short": "الزلزلة",
  "long": "سورة الزلزلة"
  },
  "en": {
  "short": "Az-Zalzala",
  "long": "Sura Az-Zalzala"
  },
  "id": {
  "short": "Az-Zalzalah",
  "long": "Surah Az-Zalzalah"
  },
  "translation": {
  "en": "The Earthquake",
  "id": "Guncangan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 8 ayat, termasuk golongan surat-surat Madaniyyah diturunkan sesudah surat An Nisaa'. Nama Al Zalzalah diambil dari kata: Zilzaal yang terdapat pada ayat pertama surat ini yang berarti goncangan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/099.mp3"
  }
  },
  {
  "number": 100,
  "ayahCount": 11,
  "sequence": 14,
  "asma": {
  "ar": {
  "short": "العاديات",
  "long": "سورة العاديات"
  },
  "en": {
  "short": "Al-Aadiyaat",
  "long": "Sura Al-Aadiyaat"
  },
  "id": {
  "short": "Al-'Adiyat",
  "long": "Surah Al-'Adiyat"
  },
  "translation": {
  "en": "The Chargers",
  "id": "Kuda Yang Berlari Kencang"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 11 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al'Ashr. Nama Al 'Aadiyaat diambil dari kata Al 'Aadiyaat yang terdapat pada ayat pertama surat ini, artinya yang berlari kencang.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/100.mp3"
  }
  },
  {
  "number": 101,
  "ayahCount": 11,
  "sequence": 30,
  "asma": {
  "ar": {
  "short": "القارعة",
  "long": "سورة القارعة"
  },
  "en": {
  "short": "Al-Qaari'a",
  "long": "Sura Al-Qaari'a"
  },
  "id": {
  "short": "Al-Qari'ah",
  "long": "Surah Al-Qari'ah"
  },
  "translation": {
  "en": "The Calamity",
  "id": "Hari Kiamat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 11 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Quraisy. Nama Al Qaari'ah diambil dari kata Al Qaari'ah yang terdapat pada ayat pertama, artinya mengetok dengan keras, kemudian kata ini dipakai untuk nama hari kiamat.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/101.mp3"
  }
  },
  {
  "number": 102,
  "ayahCount": 8,
  "sequence": 16,
  "asma": {
  "ar": {
  "short": "التكاثر",
  "long": "سورة التكاثر"
  },
  "en": {
  "short": "At-Takaathur",
  "long": "Sura At-Takaathur"
  },
  "id": {
  "short": "At-Takasur",
  "long": "Surah At-Takasur"
  },
  "translation": {
  "en": "Competition",
  "id": "Bermegah-Megahan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat At Takaatsur terdiri atas 8 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Kautsar. Dinamai At Takaatsur (bermegah-megahan) diambil dari perkataan At Takaatsur yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/102.mp3"
  }
  },
  {
  "number": 103,
  "ayahCount": 3,
  "sequence": 13,
  "asma": {
  "ar": {
  "short": "العصر",
  "long": "سورة العصر"
  },
  "en": {
  "short": "Al-Asr",
  "long": "Sura Al-Asr"
  },
  "id": {
  "short": "Al-'Asr",
  "long": "Surah Al-'Asr"
  },
  "translation": {
  "en": "The Declining Day, Epoch",
  "id": "Asar"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al 'Ashr terdiri atas 3 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Alam Nasyrah. Dinamai Al 'Ashr (masa) diambil dari perkataan Al 'Ashr yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/103.mp3"
  }
  },
  {
  "number": 104,
  "ayahCount": 9,
  "sequence": 32,
  "asma": {
  "ar": {
  "short": "الهمزة",
  "long": "سورة الهمزة"
  },
  "en": {
  "short": "Al-Humaza",
  "long": "Sura Al-Humaza"
  },
  "id": {
  "short": "Al-Humazah",
  "long": "Surah Al-Humazah"
  },
  "translation": {
  "en": "The Traducer",
  "id": "Pengumpat"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Humazah terdiri atas 9 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Qiyaamah. Dinamai Al Humazah (pengumpat) diambil dari perkataan Humazah yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/104.mp3"
  }
  },
  {
  "number": 105,
  "ayahCount": 5,
  "sequence": 19,
  "asma": {
  "ar": {
  "short": "الفيل",
  "long": "سورة الفيل"
  },
  "en": {
  "short": "Al-Fil",
  "long": "Sura Al-Fil"
  },
  "id": {
  "short": "Al-Fil",
  "long": "Surah Al-Fil"
  },
  "translation": {
  "en": "The Elephant",
  "id": "Gajah"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 5 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat Al Kaafirun. Nama Al Fiil diambil dari kata Al Fiil yang terdapat pada ayat pertama surat ini, artinya gajah. Surat Al Fiil mengemukakan cerita pasukan bergajah dari Yaman yang dipimpin oleh Abrahah yang ingin meruntuhkan Ka'bah di Mekah. Peristiwa ini terjadi pada tahun Nabi Muhammad s.a.w. dilahirkan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/105.mp3"
  }
  },
  {
  "number": 106,
  "ayahCount": 4,
  "sequence": 29,
  "asma": {
  "ar": {
  "short": "قريش",
  "long": "سورة قريش"
  },
  "en": {
  "short": "Quraish",
  "long": "Sura Quraish"
  },
  "id": {
  "short": "Quraisy",
  "long": "Surah Quraisy"
  },
  "translation": {
  "en": "Quraysh",
  "id": "Quraisy"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 4 ayat, termasuk golongan surat-surat Makkiyyah dan diturunkan sesudah surat At Tiin. Nama Quraisy diambil dari kata Quraisy yang terdapat pada ayat pertama, artinya suku Quraisy. Suku Quraisy adalah suku yang mendapat  kehormatan untuk memelihara Ka'bah.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/106.mp3"
  }
  },
  {
  "number": 107,
  "ayahCount": 7,
  "sequence": 17,
  "asma": {
  "ar": {
  "short": "الماعون",
  "long": "سورة الماعون"
  },
  "en": {
  "short": "Al-Maa'un",
  "long": "Sura Al-Maa'un"
  },
  "id": {
  "short": "Al-Ma'un",
  "long": "Surah Al-Ma'un"
  },
  "translation": {
  "en": "Almsgiving",
  "id": "Barang Yang Berguna"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 7 ayat, termasuk golongan surat-surat Makkiyyah, diturunkan sesudah surat At Taakatsur. Nama Al Maa'uun diambil dari kata Al Maa'uun yang terdapat pada ayat 7, artinya barang-barang yang berguna.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/107.mp3"
  }
  },
  {
  "number": 108,
  "ayahCount": 3,
  "sequence": 15,
  "asma": {
  "ar": {
  "short": "الكوثر",
  "long": "سورة الكوثر"
  },
  "en": {
  "short": "Al-Kawthar",
  "long": "Sura Al-Kawthar"
  },
  "id": {
  "short": "Al-Kausar",
  "long": "Surah Al-Kausar"
  },
  "translation": {
  "en": "Abundance",
  "id": "Pemberian Yang Banyak"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Kautsar terdiri atas 3 ayat, termasuk golongan surat-surat  Makkiyyah diturunkan sesudah surat Al 'Aadiyaat. Dinamai Al Kautsar (nikmat yang banyak) diambil dari perkataan Al Kautsar yang terdapat pada ayat pertama surat ini.Surat ini sebagai penghibur hati Nabi Muhammad s.a.w.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/108.mp3"
  }
  },
  {
  "number": 109,
  "ayahCount": 6,
  "sequence": 18,
  "asma": {
  "ar": {
  "short": "الكافرون",
  "long": "سورة الكافرون"
  },
  "en": {
  "short": "Al-Kaafiroon",
  "long": "Sura Al-Kaafiroon"
  },
  "id": {
  "short": "Al-Kafirun",
  "long": "Surah Al-Kafirun"
  },
  "translation": {
  "en": "The Disbelievers",
  "id": "Orang-Orang kafir"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat Al Kaafiruun terdiri atas 6 ayat, termasuk golongan surat-surat  Makkiyyah, diturunkan sesudah surat Al Maa'uun. Dinamai Al Kaafiruun (orang-orang kafir), diambil dari perkataan  Al Kaafiruun yang terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/109.mp3"
  }
  },
  {
  "number": 110,
  "ayahCount": 3,
  "sequence": 114,
  "asma": {
  "ar": {
  "short": "النصر",
  "long": "سورة النصر"
  },
  "en": {
  "short": "An-Nasr",
  "long": "Sura An-Nasr"
  },
  "id": {
  "short": "An-Nasr",
  "long": "Surah An-Nasr"
  },
  "translation": {
  "en": "Divine Support",
  "id": "Pertolongan"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مدينة",
  "id": "Madaniyyah",
  "en": "Medinan"
  },
  "tafsir": {
  "id": "Surat An Nashr terdiri atas 3 ayat, termasuk golongan surat-surat  Madaniyyah yang diturunkan di Mekah sesudah surat At Taubah.  Dinamai An Nashr (pertolongan) diambil dari perkataan Nashr yang  terdapat pada ayat pertama surat ini.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/110.mp3"
  }
  },
  {
  "number": 111,
  "ayahCount": 5,
  "sequence": 6,
  "asma": {
  "ar": {
  "short": "المسد",
  "long": "سورة المسد"
  },
  "en": {
  "short": "Al-Masad",
  "long": "Sura Al-Masad"
  },
  "id": {
  "short": "Al-Lahab",
  "long": "Surah Al-Lahab"
  },
  "translation": {
  "en": "The Palm Fibre",
  "id": "Api Yang Bergejolak"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 5 ayat, termasuk golongan surat-surat Makkiyyah,  diturunkan sesudah surat Al Fath. Nama Al Lahab diambil dari kata  Al Lahab yang terdapat pada ayat ketiga surat ini yang artinya gejolak  api. Surat ini juga dinamakan surat Al Masad.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/111.mp3"
  }
  },
  {
  "number": 112,
  "ayahCount": 4,
  "sequence": 22,
  "asma": {
  "ar": {
  "short": "الإخلاص",
  "long": "سورة الإخلاص"
  },
  "en": {
  "short": "Al-Ikhlaas",
  "long": "Sura Al-Ikhlaas"
  },
  "id": {
  "short": "Al-Ikhlas",
  "long": "Surah Al-Ikhlas"
  },
  "translation": {
  "en": "Sincerity",
  "id": "Ikhlas"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 4 ayat, termasuk golongan surat-surat  Makkiyyah, diturunkan sesudah sesudah surat An Naas. Dinamakan Al Ikhlas karena surat ini sepenuhnya menegaskan kemurnian keesaan Allah s.w.t.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/112.mp3"
  }
  },
  {
  "number": 113,
  "ayahCount": 5,
  "sequence": 20,
  "asma": {
  "ar": {
  "short": "الفلق",
  "long": "سورة الفلق"
  },
  "en": {
  "short": "Al-Falaq",
  "long": "Sura Al-Falaq"
  },
  "id": {
  "short": "Al-Falaq",
  "long": "Surah Al-Falaq"
  },
  "translation": {
  "en": "The Dawn",
  "id": "Subuh"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 5 ayat, termasuk golongan surat-surat Makkiyah, diturunkan sesudah surat Al Fiil. Nama Al Falaq diambil dari kata Al Falaq yang terdapat pada ayat pertama surat ini yang artinya waktu subuh. Diriwayatkan oleh Abu Daud, At Tirmizi dan An Nasa-i dari 'Uqbah bin 'Aamir bahwa Rasulullah s.a.w. bersembahyang dengan membaca surat Al Falaq  dan surat An Naas dalam perjalanan.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/113.mp3"
  }
  },
  {
  "number": 114,
  "ayahCount": 6,
  "sequence": 21,
  "asma": {
  "ar": {
  "short": "الناس",
  "long": "سورة الناس"
  },
  "en": {
  "short": "An-Naas",
  "long": "Sura An-Naas"
  },
  "id": {
  "short": "An-Nas",
  "long": "Surah An-Nas"
  },
  "translation": {
  "en": "Mankind",
  "id": "Manusia"
  }
  },
  "preBismillah": {
  "text": {
  "ar": "﻿بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
  "read": "Bismillaahir Rahmaanir Raheem"
  },
  "translation": {
  "en": "In the name of Allah, the Entirely Merciful, the Especially Merciful.",
  "id": "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang."
  }
  },
  "type": {
  "ar": "مكة",
  "id": "Makkiyyah",
  "en": "Meccan"
  },
  "tafsir": {
  "id": "Surat ini terdiri atas 6 ayat, termasuk golongan surat-surat Makkiyah,  diturunkan sesudah surat Al Falaq. Nama An Naas diambil dari An Naas yang berulang kali disebut dalam surat ini yang artinya manusia.",
  "en": null
  },
  "recitation": {
  "full": "http://download.quranicaudio.com/quran/ahmed_ibn_3ali_al-3ajamy/114.mp3"
  }
  }
  ]
  
